(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4274],{

/***/ 74681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mf": function() { return /* reexport */ FilterBoxCheckbox; },
  "_k": function() { return /* reexport */ FilterBoxSlider; }
});

// UNUSED EXPORTS: Indicator

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/common/advance_search/advance/indector/Indicator.jsx




var Indicator = function Indicator() {
  return /*#__PURE__*/_jsx("div", {
    className: styles.indector_wrapper,
    children: /*#__PURE__*/_jsxs("ul", {
      children: [/*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx("span", {
          children: "Australia"
        }), /*#__PURE__*/_jsx("button", {
          children: "x"
        })]
      }), /*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx("span", {
          children: "Melbourne"
        }), /*#__PURE__*/_jsx("button", {
          children: "x"
        })]
      }), /*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx("span", {
          children: "$4.5-$40"
        }), /*#__PURE__*/_jsx("button", {
          children: "x"
        })]
      }), /*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx("span", {
          children: "Australia"
        }), /*#__PURE__*/_jsx("button", {
          children: "x"
        })]
      }), /*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx("span", {
          children: "Melbourne"
        }), /*#__PURE__*/_jsx("button", {
          children: "x"
        })]
      }), /*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx("span", {
          children: "$4.5-$40"
        }), /*#__PURE__*/_jsx("button", {
          children: "x"
        })]
      })]
    })
  });
};
/* harmony default export */ var indector_Indicator = ((/* unused pure expression or super */ null && (Indicator)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Collapse/Collapse.js
var Collapse = __webpack_require__(51627);
// EXTERNAL MODULE: ./node_modules/react-checkbox-tree/lib/index.browser.js
var index_browser = __webpack_require__(28388);
var index_browser_default = /*#__PURE__*/__webpack_require__.n(index_browser);
// EXTERNAL MODULE: ./node_modules/react-checkbox-tree/lib/react-checkbox-tree.css
var react_checkbox_tree = __webpack_require__(37846);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var hi_index_esm = __webpack_require__(53854);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./_modules/study/common/advance_search/advance/filter_box/filter_box_checkbox.module.scss
var filter_box_checkbox_module = __webpack_require__(54650);
var filter_box_checkbox_module_default = /*#__PURE__*/__webpack_require__.n(filter_box_checkbox_module);
;// CONCATENATED MODULE: ./_modules/study/common/advance_search/advance/filter_box/filter_box_checkbox.jsx

var _excluded = ["data", "title", "selected", "expanded", "search", "loading", "type"];








 // types (collapsible, normal)



var FilterBoxCheckbox = function FilterBoxCheckbox(_ref) {
  var data = _ref.data,
      title = _ref.title,
      selected = _ref.selected,
      expanded = _ref.expanded,
      _ref$search = _ref.search,
      search = _ref$search === void 0 ? false : _ref$search,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "collapsible" : _ref$type,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useState = (0,react.useState)(true),
      cardOpen = _useState[0],
      setCardOpen = _useState[1];

  var handleCard = function handleCard() {
    setCardOpen(!cardOpen);
  };

  var onCheck = function onCheck(checked) {
    if (props.onChange) props.onChange(checked);
  };

  var onExpand = function onExpand(expanded) {
    if (props.getExpand) props.getExpand(expanded);
  };

  if (data && data.length > 0) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [type == "collapsible" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (filter_box_checkbox_module_default()).filter_option,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          onClick: handleCard,
          className: (filter_box_checkbox_module_default()).option_title_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (filter_box_checkbox_module_default()).option_title,
            children: title || ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (filter_box_checkbox_module_default()).icon,
            children: cardOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiChevronUp */.rH8, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiChevronDown */.bTu, {})
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (filter_box_checkbox_module_default()).filter_checkbox_wrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse/* default */.Z, {
            "in": cardOpen,
            timeout: "auto",
            unmountOnExit: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((index_browser_default()), {
              checked: selected,
              expanded: expanded,
              nodes: data,
              className: "test",
              onCheck: onCheck,
              onExpand: onExpand,
              disabled: loading,
              icons: {
                check: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCheckBox */.y5A, {}),
                uncheck: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCheckBoxOutlineBlank */.hrt, {}),
                halfCheck: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCheckBox */.y5A, {}),
                expandClose: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {}),
                expandOpen: /*#__PURE__*/(0,jsx_runtime.jsx)(hi_index_esm/* HiMinus */.bQR, {}),
                expandAll: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdExpand */.Bds, {}),
                collapseAll: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCloseFullscreen */.$WQ, {}),
                parentClose: false,
                parentOpen: false,
                leaf: false
              }
            })
          })
        })]
      }), type == "normal" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (filter_box_checkbox_module_default()).filter_checkbox_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((index_browser_default()), {
          checked: selected,
          expanded: expanded,
          nodes: data,
          className: "test",
          onCheck: onCheck,
          onExpand: onExpand,
          disabled: loading,
          icons: {
            check: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCheckBox */.y5A, {}),
            uncheck: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCheckBoxOutlineBlank */.hrt, {}),
            halfCheck: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCheckBox */.y5A, {}),
            expandClose: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {}),
            expandOpen: /*#__PURE__*/(0,jsx_runtime.jsx)(hi_index_esm/* HiMinus */.bQR, {}),
            expandAll: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdExpand */.Bds, {}),
            collapseAll: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCloseFullscreen */.$WQ, {}),
            parentClose: false,
            parentOpen: false,
            leaf: false
          }
        })
      })]
    });
  }
};
/* harmony default export */ var filter_box_checkbox = ((/* unused pure expression or super */ null && (FilterBoxCheckbox)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Slider/Slider.js + 4 modules
var Slider = __webpack_require__(45996);
// EXTERNAL MODULE: ./_modules/study/common/advance_search/advance/filter_box/filter_box_slider.module.scss
var filter_box_slider_module = __webpack_require__(4644);
var filter_box_slider_module_default = /*#__PURE__*/__webpack_require__.n(filter_box_slider_module);
;// CONCATENATED MODULE: ./_modules/study/common/advance_search/advance/filter_box/filter_box_slider.jsx


var filter_box_slider_excluded = ["title", "range", "value", "onChange", "loading", "icon", "offset", "type"];



 // type (collapsible, normal)



var FilterBoxSlider = function FilterBoxSlider(_ref) {
  var _range$, _range$2, _range$3, _range$4;

  var title = _ref.title,
      range = _ref.range,
      value = _ref.value,
      onChange = _ref.onChange,
      loading = _ref.loading,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? false : _ref$icon,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? false : _ref$offset,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "collapsible" : _ref$type,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, filter_box_slider_excluded);

  var _React$useState = react.useState(true),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _React$useState3 = react.useState(value),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      valueState = _React$useState4[0],
      setValue = _React$useState4[1];

  var handleClick = function handleClick() {
    setOpen(!open);
  };

  var handleChange = function handleChange(event, newValue) {
    setValue(newValue);
  };

  var changeCommitted = function changeCommitted(event, newValue) {
    if (onChange) {
      onChange(newValue);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [type == "collapsible" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (filter_box_slider_module_default()).filter_option,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        onClick: handleClick,
        className: (filter_box_slider_module_default()).option_title_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (filter_box_slider_module_default()).option_title,
          children: title || ""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (filter_box_slider_module_default()).icon,
          children: open ? /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiChevronUp */.rH8, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiChevronDown */.bTu, {})
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse/* default */.Z, {
        "in": open,
        timeout: "auto",
        unmountOnExit: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (filter_box_slider_module_default()).filter_slider_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (filter_box_slider_module_default()).slider_range_text,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: (filter_box_slider_module_default()).currncy,
              children: [offset && offset == "left" && icon && icon, valueState && valueState[0], " ", offset && offset == "right" && icon && icon]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: (filter_box_slider_module_default()).currncy,
              children: [offset && offset == "left" && icon && icon, valueState && valueState[1], " ", offset && offset == "right" && icon && icon]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Slider/* default */.ZP, {
            value: valueState,
            onChange: handleChange,
            onChangeCommitted: changeCommitted,
            valueLabelDisplay: "off",
            min: (_range$ = range[0]) !== null && _range$ !== void 0 ? _range$ : 0,
            max: (_range$2 = range[1]) !== null && _range$2 !== void 0 ? _range$2 : 1,
            className: (filter_box_slider_module_default()).slideContainer,
            disabled: loading
          })]
        })
      })]
    }), type == "normal" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (filter_box_slider_module_default()).filter_slider_wrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (filter_box_slider_module_default()).slider_range_text,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (filter_box_slider_module_default()).currncy,
          children: [offset && offset == "left" && icon && icon, valueState && valueState[0], " ", offset && offset == "right" && icon && icon]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (filter_box_slider_module_default()).currncy,
          children: [offset && offset == "left" && icon && icon, valueState && valueState[1], " ", offset && offset == "right" && icon && icon]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Slider/* default */.ZP, {
        value: valueState,
        onChange: handleChange,
        onChangeCommitted: changeCommitted,
        valueLabelDisplay: "off",
        min: (_range$3 = range[0]) !== null && _range$3 !== void 0 ? _range$3 : 0,
        max: (_range$4 = range[1]) !== null && _range$4 !== void 0 ? _range$4 : 1,
        className: (filter_box_slider_module_default()).slideContainer,
        disabled: loading
      })]
    })]
  });
};
/* harmony default export */ var filter_box_slider = ((/* unused pure expression or super */ null && (FilterBoxSlider)));
;// CONCATENATED MODULE: ./_modules/study/common/advance_search/advance/index.js




/***/ }),

/***/ 33802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UniThumbBoxMobile */
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83618);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(70754);
/* harmony import */ var _unisearch_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74155);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72145);
/* harmony import */ var _recoil_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8612);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89093);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(89583);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2804);
/* harmony import */ var _uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(40688);
/* harmony import */ var _uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var FavoriteAction = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3609), __webpack_require__.e(726)]).then(__webpack_require__.bind(__webpack_require__, 25494));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(25494)];
    }
  }
});
var CompareAction = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3609), __webpack_require__.e(180)]).then(__webpack_require__.bind(__webpack_require__, 76723));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(76723)];
    }
  }
});
var UniThumbBoxMobile = function UniThumbBoxMobile(_ref) {
  var _item$country, _item$logo, _item$logo2, _item$country2, _item$city, _item$city2, _item$state, _item$state2, _item$country3, _item$country4, _item$documentInfo, _item$documentInfo2, _item$course, _item$course2;

  var item = _ref.item;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
  var profileInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_10__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_5__/* .authAtom */ .L4);
  var systemActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_4__/* .useSystemActions */ .x3)();
  var sliceItems = item && item.course.length > 0 && item.course.slice(0, 4);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)([]),
      loader = _useState[0],
      setLoader = _useState[1];

  var MoreExam = function MoreExam(_ref2) {
    var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_ref2),
        exams = _ref3.slice(0);

    if (!exams || exams.length <= 1) return false;
    exams.shift();

    if (exams && exams.length > 0) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
        className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().examNumber),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("strong", {
          children: ["+", exams.length]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("ul", {
          className: "uni-tooltip ".concat((_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().examlist)),
          children: exams.map(function (ex, i) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("li", {
              children: [ex.exam_examName, " : ", ex.course_score, " "]
            }, i);
          })
        })]
      });
    }
  }; //return with search query


  var goSearchResult = /*#__PURE__*/function () {
    var _ref4 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(returnPath, university) {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoader([university]); // await router.push({
              //   pathname: returnPath,
              //   query: router.query,
              // });

              window.open("".concat(returnPath, "?").concat((0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .objectToQueryString */ .nZ)(_objectSpread(_objectSpread({}, router.query), {}, {
                page: 1
              }))), "_blank");
              setLoader([]);
              return _context.abrupt("return", true);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function goSearchResult(_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
    className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_search_box),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
      className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().logo_uni_info_wrapper),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
        legacyBehavior: true,
        href: "/study/".concat(item === null || item === void 0 ? void 0 : (_item$country = item.country) === null || _item$country === void 0 ? void 0 : _item$country.slug, "/university/").concat(item === null || item === void 0 ? void 0 : item.slug),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
          className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().logo_wrapper),
          target: "_blank",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
            src: (item === null || item === void 0 ? void 0 : (_item$logo = item.logo) === null || _item$logo === void 0 ? void 0 : _item$logo.src) || getAssets("assets/images/uni-profile/logo-placeholder.png"),
            alt: item === null || item === void 0 ? void 0 : (_item$logo2 = item.logo) === null || _item$logo2 === void 0 ? void 0 : _item$logo2.alt
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
        className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_brief_wrapper),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
          legacyBehavior: true,
          href: "/study/".concat(item === null || item === void 0 ? void 0 : (_item$country2 = item.country) === null || _item$country2 === void 0 ? void 0 : _item$country2.slug, "/university/").concat(item === null || item === void 0 ? void 0 : item.slug),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
            target: "_blank",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h4", {
              className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_name),
              children: item === null || item === void 0 ? void 0 : item.universityName
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
          className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_address_wrapper),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
            className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_address),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_15__/* .FaUniversity */ .Q7H, {
              className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_address_icon)
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("span", {
              className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_address_text),
              children: [item.universityType && (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .ucfirst */ .Ps)(item.universityType), "University, Estd ", item === null || item === void 0 ? void 0 : item.estd]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
            className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_address),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_15__/* .FaMapMarkerAlt */ .Nh4, {
              className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_address_icon)
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("span", {
              className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_address_text),
              children: [(item === null || item === void 0 ? void 0 : (_item$city = item.city) === null || _item$city === void 0 ? void 0 : _item$city.name) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
                children: [item === null || item === void 0 ? void 0 : (_item$city2 = item.city) === null || _item$city2 === void 0 ? void 0 : _item$city2.name, ","]
              }), " ", (item === null || item === void 0 ? void 0 : (_item$state = item.state) === null || _item$state === void 0 ? void 0 : _item$state.name) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
                children: [item === null || item === void 0 ? void 0 : (_item$state2 = item.state) === null || _item$state2 === void 0 ? void 0 : _item$state2.name, ","]
              }), " ", (item === null || item === void 0 ? void 0 : (_item$country3 = item.country) === null || _item$country3 === void 0 ? void 0 : _item$country3.name) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
                children: item === null || item === void 0 ? void 0 : (_item$country4 = item.country) === null || _item$country4 === void 0 ? void 0 : _item$country4.name
              })]
            })]
          })]
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
      className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_review_warpper),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(FavoriteAction, {
        referance: "university",
        referanceId: parseInt(item.universityId),
        is_favorite: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isUniFavorite */ .bt)(profileInfo, item.universityId)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(CompareAction, {
        referance: "university",
        referanceId: parseInt(item.universityId),
        is_compared: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isUniCompare */ .j1)(profileInfo, item.universityId)
      })]
    }), item && !(0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isEmpty */ .xb)(item === null || item === void 0 ? void 0 : item.documentInfo) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_unisearch_common__WEBPACK_IMPORTED_MODULE_2__/* .DownloadGuide */ .E6, {
      customStyles: {
        root: {
          fontSize: "10px",
          marginBottom: "15px"
        }
      },
      fileSrc: item === null || item === void 0 ? void 0 : (_item$documentInfo = item.documentInfo) === null || _item$documentInfo === void 0 ? void 0 : _item$documentInfo.documentSrc,
      documentId: item === null || item === void 0 ? void 0 : (_item$documentInfo2 = item.documentInfo) === null || _item$documentInfo2 === void 0 ? void 0 : _item$documentInfo2.documentId,
      documentType: "prospectus",
      universityId: parseInt(item.universityId)
    }), item.course && item.course.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
      className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().courses_wrapper),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("ul", {
        children: sliceItems && sliceItems.map(function (course, index) {
          var _item$country5, _course$exam$, _course$exam$2, _course$courseDuratio, _course$courseDuratio2;

          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("li", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
              legacyBehavior: true,
              href: "/study/".concat(item === null || item === void 0 ? void 0 : (_item$country5 = item.country) === null || _item$country5 === void 0 ? void 0 : _item$country5.slug, "/university/").concat(item === null || item === void 0 ? void 0 : item.slug, "/").concat(course === null || course === void 0 ? void 0 : course.slug),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                target: "_blank",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h4", {
                  className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().course_name),
                  children: course === null || course === void 0 ? void 0 : course.courseName
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().course_desc),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().course_head),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                  children: "1st Year Total Fees"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                  children: "Eligibility"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                  children: "Duration"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("span", {
                  className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().comp_icons),
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(FavoriteAction, {
                    referance: "course",
                    referanceId: parseInt(course.courseId),
                    is_favorite: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isCourseFavorite */ .R8)(profileInfo, course.courseId)
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(CompareAction, {
                    referance: "course",
                    referanceId: parseInt(course.courseId),
                    is_compared: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isCourseCompare */ ._u)(profileInfo, course.courseId)
                  })]
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().course_body),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("span", {
                  children: [item.country && item.country.currencySymbol ? item.country.currencySymbol : "", course.tuitionfees && course.tuitionfees.amountFrom ? course.tuitionfees.amountFrom : 0, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("span", {
                    style: {
                      fontSize: "9px"
                    },
                    children: ["(", item.country && item.country.currency ? item.country.currency : "", ")"]
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                    className: "".concat((_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().exams), " relative"),
                    children: [course === null || course === void 0 ? void 0 : (_course$exam$ = course.exam[0]) === null || _course$exam$ === void 0 ? void 0 : _course$exam$.exam_examName, " :", " ", course === null || course === void 0 ? void 0 : (_course$exam$2 = course.exam[0]) === null || _course$exam$2 === void 0 ? void 0 : _course$exam$2.course_score, " ", MoreExam(course === null || course === void 0 ? void 0 : course.exam)]
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("span", {
                  children: [(_course$courseDuratio = course.courseDuration) !== null && _course$courseDuratio !== void 0 ? _course$courseDuratio : "", " ", (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .ucfirst */ .Ps)((_course$courseDuratio2 = course.courseDurationType) !== null && _course$courseDuratio2 !== void 0 ? _course$courseDuratio2 : "Months")]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {})]
              })]
            })]
          }, "co_".concat(index));
        })
      }), item.course && item.course.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: (_uni_thumb_box_mobile_module_scss__WEBPACK_IMPORTED_MODULE_13___default().course_link),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("button", {
          onClick: function onClick() {
            var _item$country6;

            goSearchResult("/study/".concat(item === null || item === void 0 ? void 0 : (_item$country6 = item.country) === null || _item$country6 === void 0 ? void 0 : _item$country6.slug, "/university/").concat(item === null || item === void 0 ? void 0 : item.slug, "/search-courses"), item.universityId);
          },
          children: [loader && loader.includes(item.universityId) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            size: "10px",
            color: "inherit"
          }), " ", "View More ", parseInt(item === null || item === void 0 ? void 0 : (_item$course = item.course) === null || _item$course === void 0 ? void 0 : _item$course.length) - 4, " ", parseInt(item === null || item === void 0 ? void 0 : (_item$course2 = item.course) === null || _item$course2 === void 0 ? void 0 : _item$course2.length) > 5 ? "Courses ›" : "Course ›"]
        })
      })]
    })]
  });
};
/* harmony default export */ __webpack_exports__["Z"] = (UniThumbBoxMobile);

/***/ }),

/***/ 92186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(83618);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4730);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(90926);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(70754);
/* harmony import */ var _unisearch_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74155);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72145);
/* harmony import */ var _recoil_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8612);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89093);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);
/* harmony import */ var react_icons_bi__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47516);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(89583);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5434);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2804);
/* harmony import */ var _uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8202);
/* harmony import */ var _uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);




var _excluded = ["item"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable @next/next/no-img-element */

/* eslint-disable react/jsx-no-target-blank */

















var FavoriteAction = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3609), __webpack_require__.e(726)]).then(__webpack_require__.bind(__webpack_require__, 25494));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(25494)];
    }
  }
});
var CompareAction = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3609), __webpack_require__.e(180)]).then(__webpack_require__.bind(__webpack_require__, 76723));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(76723)];
    }
  }
});

var UniThumbListBox = function UniThumbListBox(_ref) {
  var _item$country, _item$logo, _item$logo2, _item$country2, _item$city, _item$city2, _item$state, _item$state2, _item$country3, _item$country4, _item$country5, _item$course$length, _item$rating, _item$rating2, _item$rating3, _item$rating4, _item$documentInfo, _item$documentInfo2, _item$course, _item$course2, _item$course3;

  var item = _ref.item,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_ref, _excluded);

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
  var profileInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_10__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_5__/* .authAtom */ .L4);
  var systemActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_4__/* .useSystemActions */ .x3)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)([]),
      loader = _useState[0],
      setLoader = _useState[1];

  var sliceItems = item && item.course.length > 0 && item.course.slice(0, 4);

  var MoreExam = function MoreExam(_ref2) {
    var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_ref2),
        exams = _ref3.slice(0);

    if (!exams || exams.length <= 1) return false;
    exams.shift();

    if (exams && exams.length > 0) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
        className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().examNumber),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("strong", {
          children: ["+", exams.length, " "]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("ul", {
          className: "uni-tooltip ".concat((_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().examlist)),
          children: exams.map(function (ex, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("li", {
              children: [ex.exam_examName, " : ", ex.course_score, " "]
            }, "ex_".concat(index));
          })
        })]
      });
    }
  }; //return with search query


  var goSearchResult = /*#__PURE__*/function () {
    var _ref4 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(returnPath, university) {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoader([university]); // router.push({
              //   pathname: returnPath,
              //   query: objectToQueryString(router.query),
              // });

              window.open("".concat(returnPath, "?").concat((0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .objectToQueryString */ .nZ)(_objectSpread(_objectSpread({}, router.query), {}, {
                page: 1
              }))), "_blank");
              setLoader([]);
              return _context.abrupt("return", true);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function goSearchResult(_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
      className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().grid_box),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
        className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().head_wrapper),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
          className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().left),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
            legacyBehavior: true,
            href: "/study/".concat(item === null || item === void 0 ? void 0 : (_item$country = item.country) === null || _item$country === void 0 ? void 0 : _item$country.slug, "/university/").concat(item === null || item === void 0 ? void 0 : item.slug),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
              className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().logo_wrapper),
              target: "_blank",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
                src: (item === null || item === void 0 ? void 0 : (_item$logo = item.logo) === null || _item$logo === void 0 ? void 0 : _item$logo.src) || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAssets */ .Vh)("assets/images/uni-profile/logo-placeholder.png"),
                alt: item === null || item === void 0 ? void 0 : (_item$logo2 = item.logo) === null || _item$logo2 === void 0 ? void 0 : _item$logo2.alt,
                className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().logo)
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
            className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().infos),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
              legacyBehavior: true,
              href: "/study/".concat(item === null || item === void 0 ? void 0 : (_item$country2 = item.country) === null || _item$country2 === void 0 ? void 0 : _item$country2.slug, "/university/").concat(item === null || item === void 0 ? void 0 : item.slug),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().name),
                target: "_blank",
                children: item === null || item === void 0 ? void 0 : item.universityName
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().info),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().icon),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_16__/* .MdLocationOn */ .$0r, {
                  style: {
                    fontSize: "14px"
                  }
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("span", {
                className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().address),
                children: [(item === null || item === void 0 ? void 0 : (_item$city = item.city) === null || _item$city === void 0 ? void 0 : _item$city.name) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
                  children: [item === null || item === void 0 ? void 0 : (_item$city2 = item.city) === null || _item$city2 === void 0 ? void 0 : _item$city2.name, ","]
                }), " ", (item === null || item === void 0 ? void 0 : (_item$state = item.state) === null || _item$state === void 0 ? void 0 : _item$state.name) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
                  children: [item === null || item === void 0 ? void 0 : (_item$state2 = item.state) === null || _item$state2 === void 0 ? void 0 : _item$state2.name, ","]
                }), " ", (item === null || item === void 0 ? void 0 : (_item$country3 = item.country) === null || _item$country3 === void 0 ? void 0 : _item$country3.name) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
                  children: [" ", item === null || item === void 0 ? void 0 : (_item$country4 = item.country) === null || _item$country4 === void 0 ? void 0 : _item$country4.name]
                })]
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().info),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().icon),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_17__/* .FaUniversity */ .Q7H, {})
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("span", {
                className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().address),
                children: [item.universityType && (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .ucfirst */ .Ps)(item.universityType), " ", "University, Estd ", item === null || item === void 0 ? void 0 : item.estd]
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().info),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().icon),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_17__/* .FaBook */ .Mp$, {})
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                legacyBehavior: true,
                href: "/study/".concat(item === null || item === void 0 ? void 0 : (_item$country5 = item.country) === null || _item$country5 === void 0 ? void 0 : _item$country5.slug, "/university/").concat(item === null || item === void 0 ? void 0 : item.slug, "/courses"),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                  className: "".concat((_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().address), " ").concat((_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().link_course)),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("span", {
                    children: [" Courses ", (_item$course$length = item.course.length) !== null && _item$course$length !== void 0 ? _item$course$length : 0]
                  })
                })
              })]
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
          className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().brief_right_wrapper),
          children: [parseInt(item === null || item === void 0 ? void 0 : (_item$rating = item.rating) === null || _item$rating === void 0 ? void 0 : _item$rating.totalRating) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().info_rating_number),
              children: [parseInt(item === null || item === void 0 ? void 0 : (_item$rating2 = item.rating) === null || _item$rating2 === void 0 ? void 0 : _item$rating2.finalRating), "(", parseInt(item === null || item === void 0 ? void 0 : (_item$rating3 = item.rating) === null || _item$rating3 === void 0 ? void 0 : _item$rating3.totalRating), ")"]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
              className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().info_rating_stars),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                name: "read-only",
                value: parseInt(item === null || item === void 0 ? void 0 : (_item$rating4 = item.rating) === null || _item$rating4 === void 0 ? void 0 : _item$rating4.finalRating),
                readOnly: true,
                sx: {
                  mb: 1
                }
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
            className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().compare_wrapper),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(FavoriteAction, {
              referance: "university",
              referanceId: parseInt(item.universityId),
              is_favorite: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isUniFavorite */ .bt)(profileInfo, item.universityId)
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(CompareAction, {
              referance: "university",
              referanceId: parseInt(item.universityId),
              is_compared: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isUniCompare */ .j1)(profileInfo, item.universityId)
            }), item && !(0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isEmpty */ .xb)(item === null || item === void 0 ? void 0 : item.documentInfo) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_unisearch_common__WEBPACK_IMPORTED_MODULE_2__/* .DownloadGuide */ .E6, {
              customStyles: {
                root: {
                  fontSize: "10px"
                }
              },
              fileSrc: item === null || item === void 0 ? void 0 : (_item$documentInfo = item.documentInfo) === null || _item$documentInfo === void 0 ? void 0 : _item$documentInfo.documentSrc,
              documentId: item === null || item === void 0 ? void 0 : (_item$documentInfo2 = item.documentInfo) === null || _item$documentInfo2 === void 0 ? void 0 : _item$documentInfo2.documentId,
              documentType: "prospectus",
              universityId: parseInt(item.universityId)
            })]
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().head_link),
        children: item.website && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
          className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().external_link),
          style: {
            paddingTop: "10px"
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("a", {
            href: item === null || item === void 0 ? void 0 : item.website,
            target: "_blank",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
              children: "International student website"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_19__/* .BiLinkExternal */ .rpH, {})]
          })
        })
      }), (item === null || item === void 0 ? void 0 : (_item$course = item.course) === null || _item$course === void 0 ? void 0 : _item$course.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
          className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().table_wrapper),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("table", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("thead", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("tr", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("th", {
                  children: "Course Name"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("th", {
                  children: "1st Year Total Fees"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("th", {
                  className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().eligibility),
                  children: "Eligibility"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("th", {
                  children: "Duration"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("th", {})]
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("tbody", {
              children: sliceItems && sliceItems.map(function (course) {
                var _item$country6, _course$exam$, _course$exam$2, _course$courseDuratio, _course$courseDuratio2;

                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("tr", {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("td", {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("a", {
                      target: "_blank",
                      href: "/study/".concat(item === null || item === void 0 ? void 0 : (_item$country6 = item.country) === null || _item$country6 === void 0 ? void 0 : _item$country6.slug, "/university/").concat(item === null || item === void 0 ? void 0 : item.slug, "/").concat(course === null || course === void 0 ? void 0 : course.slug),
                      children: course === null || course === void 0 ? void 0 : course.courseName
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("td", {
                    children: [item.country && item.country.currencySymbol ? item.country.currencySymbol : "", course.tuitionfees && course.tuitionfees.amountFrom ? course.tuitionfees.amountFrom : 0, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("span", {
                      style: {
                        fontSize: "9px"
                      },
                      children: ["(", item.country && item.country.currency ? item.country.currency : "", ")"]
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("td", {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                      className: "".concat((_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().exams), " relative"),
                      children: [course === null || course === void 0 ? void 0 : (_course$exam$ = course.exam[0]) === null || _course$exam$ === void 0 ? void 0 : _course$exam$.exam_examName, " :", " ", course === null || course === void 0 ? void 0 : (_course$exam$2 = course.exam[0]) === null || _course$exam$2 === void 0 ? void 0 : _course$exam$2.course_score, " ", MoreExam(course === null || course === void 0 ? void 0 : course.exam)]
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("td", {
                    children: [(_course$courseDuratio = course.courseDuration) !== null && _course$courseDuratio !== void 0 ? _course$courseDuratio : "", " ", (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .ucfirst */ .Ps)((_course$courseDuratio2 = course.courseDurationType) !== null && _course$courseDuratio2 !== void 0 ? _course$courseDuratio2 : "Months")]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("td", {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                      className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().compare_wrapper),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(FavoriteAction, {
                        referance: "course",
                        referanceId: parseInt(course.courseId),
                        is_favorite: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isCourseFavorite */ .R8)(profileInfo, course.courseId)
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(CompareAction, {
                        referance: "course",
                        referanceId: parseInt(course.courseId),
                        is_compared: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isCourseCompare */ ._u)(profileInfo, course.courseId)
                      })]
                    })
                  })]
                }, "".concat(Math.random(), "_").concat(course.id));
              })
            })]
          })
        }), item.course && item.course.length > 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
          className: (_uni_thumb_list_box_module_scss__WEBPACK_IMPORTED_MODULE_14___default().view_all_link),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("button", {
            onClick: function onClick() {
              var _item$country7;

              goSearchResult("/study/".concat(item === null || item === void 0 ? void 0 : (_item$country7 = item.country) === null || _item$country7 === void 0 ? void 0 : _item$country7.slug, "/university/").concat(item === null || item === void 0 ? void 0 : item.slug, "/search-courses"), item.universityId);
            },
            children: [loader && loader.includes(item.universityId) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
              size: "10px",
              color: "inherit"
            }), " ", "View More ", parseInt(item === null || item === void 0 ? void 0 : (_item$course2 = item.course) === null || _item$course2 === void 0 ? void 0 : _item$course2.length) - 4, " ", parseInt(item === null || item === void 0 ? void 0 : (_item$course3 = item.course) === null || _item$course3 === void 0 ? void 0 : _item$course3.length) > 5 ? "Courses ›" : "Course ›"]
          })
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (UniThumbListBox);

/***/ }),

/***/ 97040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ SearchFilter; }
});

// UNUSED EXPORTS: SearchHero

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/search/search_hero.jsx





var SearchHero = function SearchHero(props) {
  var keyword = props.keyword,
      pageData = props.pageData;
  return /*#__PURE__*/_jsx("section", {
    className: "".concat(styles.section_search_hero, " ").concat((pageData === null || pageData === void 0 ? void 0 : pageData.length) < 1 ? "".concat(styles.min_height) : ""),
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.wrapper,
        children: [/*#__PURE__*/_jsxs("h1", {
          className: styles.heading,
          children: [pageData === null || pageData === void 0 ? void 0 : pageData.length, " Result showing for \"", keyword, "\""]
        }), (pageData === null || pageData === void 0 ? void 0 : pageData.length) < 1 && /*#__PURE__*/_jsx(Link, {
          legacyBehavior: true,
          href: "https://myunisearch.com/",
          children: /*#__PURE__*/_jsx("a", {
            className: "btn btn-secondary",
            children: "Back Home"
          })
        })]
      })
    })
  });
};
/* harmony default export */ var search_hero = ((/* unused pure expression or super */ null && (SearchHero)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./_modules/study/common/advance_search/advance/index.js + 3 modules
var advance = __webpack_require__(74681);
// EXTERNAL MODULE: ./_modules/study/common/uni_thumb_box_mobile/index.jsx
var uni_thumb_box_mobile = __webpack_require__(33802);
// EXTERNAL MODULE: ./_modules/study/common/uni_thumb_list_box/index.jsx
var uni_thumb_list_box = __webpack_require__(92186);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/SwipeableDrawer/SwipeableDrawer.js + 5 modules
var SwipeableDrawer = __webpack_require__(91707);
// EXTERNAL MODULE: ./_unisearch/common/ui_element/pagination/index.jsx
var pagination = __webpack_require__(59076);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./_unisearch/helpers/utils.js
var utils = __webpack_require__(90705);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./_unisearch/common/loader/course_screen.jsx
var course_screen = __webpack_require__(53469);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var bi_index_esm = __webpack_require__(47516);
// EXTERNAL MODULE: ./_modules/study/search/search_filter.module.scss
var search_filter_module = __webpack_require__(92991);
var search_filter_module_default = /*#__PURE__*/__webpack_require__.n(search_filter_module);
;// CONCATENATED MODULE: ./_modules/study/search/search_filter.jsx




var _excluded = ["pageUrl", "searchParams", "location", "courseLevel", "specialization", "examType", "fees", "courseDuration", "filterResult"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var SearchFilter = function SearchFilter(_ref) {
  var pageUrl = _ref.pageUrl,
      searchParams = _ref.searchParams,
      location = _ref.location,
      courseLevel = _ref.courseLevel,
      specialization = _ref.specialization,
      examType = _ref.examType,
      fees = _ref.fees,
      courseDuration = _ref.courseDuration,
      filterResult = _ref.filterResult,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var router = (0,next_router.useRouter)();
  var refq = router.query.refq;

  var _useState = (0,react.useState)(false),
      drawerOpen = _useState[0],
      setDrawerOpen = _useState[1];

  var toggleDrawer = function toggleDrawer(newOpen) {
    return function () {
      setDrawerOpen(newOpen);
    };
  };

  var _useState2 = (0,react.useState)(false),
      noDataFound = _useState2[0],
      setNoDataFound = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      loading = _useState3[0],
      setLoading = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      filterCollaps = _useState4[0],
      setFilterCollaps = _useState4[1];

  var _useState5 = (0,react.useState)(searchParams),
      searchQuery = _useState5[0],
      setSearchQuery = _useState5[1];

  var _useState6 = (0,react.useState)([]),
      filteredLocations = _useState6[0],
      setFilteredLocations = _useState6[1];

  var _useState7 = (0,react.useState)(0),
      filterNum = _useState7[0],
      setNumfilter = _useState7[1]; // const [locationsObj, setLocationsObj] = useState(location);
  // const [courseLevelsObj, setCourseLevelsObj] = useState(courseLevel);
  // const [specializationsObj, setSpecializationsObj] = useState(courseLevel);
  // const [examTypesObj, setExamTypesObj] = useState(examType);


  var _useState8 = (0,react.useState)(fees),
      feesObj = _useState8[0],
      setFeesObj = _useState8[1];

  var _useState9 = (0,react.useState)(courseDuration),
      durationObj = _useState9[0],
      setDurationObj = _useState9[1];

  var _useState10 = (0,react.useState)([]),
      pageData = _useState10[0],
      setPageData = _useState10[1];

  var _useState11 = (0,react.useState)(),
      pagerOption = _useState11[0],
      setPagerOption = _useState11[1]; //generating for selectbox and dropdown


  var _useState12 = (0,react.useState)([]),
      locationArray = _useState12[0],
      setLocationArray = _useState12[1];

  var _useState13 = (0,react.useState)([]),
      levelArray = _useState13[0],
      setLevelArray = _useState13[1];

  var _useState14 = (0,react.useState)([]),
      spArray = _useState14[0],
      setSpArray = _useState14[1];

  var _useState15 = (0,react.useState)([]),
      examArray = _useState15[0],
      setExamArray = _useState15[1]; //selected States


  var _useState16 = (0,react.useState)({
    checkedLocations: [],
    expandedLocations: [],
    checkedLevels: [],
    expandedLevels: [],
    checkedSpecializations: [],
    expandedSpecializations: [],
    checkedExam: [],
    expandedExam: []
  }),
      checkedState = _useState16[0],
      setCheckedState = _useState16[1];

  (0,react.useEffect)(function () {
    setSearchQuery(function (prevState) {
      var _searchParams$sp;

      return _objectSpread(_objectSpread({}, prevState), {}, {
        sp: Array.from(new Set((_searchParams$sp = searchParams === null || searchParams === void 0 ? void 0 : searchParams.sp) !== null && _searchParams$sp !== void 0 ? _searchParams$sp : [])),
        page: 1
      });
    });
  }, [pageUrl]); //generate Locations

  var generateLocation = function generateLocation() {
    if (location && location.length > 0) {
      var stArray = searchQuery && searchQuery.st ? searchQuery.st : [];
      var selectedLocation = [];
      var expandLocation = [];
      var locationsData = location.map(function (country) {
        return {
          label: country.name,
          value: country.slug,
          children: country.state && country.state.length > 0 && country.state.map(function (state) {
            if (stArray.includes(state.slug)) {
              selectedLocation.push(country.slug + "_" + state.slug);
              expandLocation.push(country.slug);
            }

            return {
              label: state.name,
              value: country.slug + "_" + state.slug,
              children: state.cities && state.cities.length > 0 && state.cities.map(function (city) {
                return {
                  label: city.name,
                  value: country.slug + "_" + state.slug + "_" + city.slug
                };
              })
            };
          })
        };
      }); //set location checked

      setTimeout(function () {
        setCheckedState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            checkedLocations: selectedLocation,
            expandedLocations: expandLocation
          });
        });
      }, 0); //set location state

      setLocationArray(locationsData);
    } else {
      setLocationArray([]);
      setCheckedState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          checkedLocations: [],
          expandedLocations: []
        });
      });
    }
  };

  (0,react.useEffect)(function () {
    generateLocation();
  }, [location]); //generate Levels

  var generateLevels = function generateLevels() {
    if (courseLevel && courseLevel.length > 0) {
      var courseLevelData = (0,helpers/* generateOptions */.uu)(courseLevel, "label", "slug", "child");
      var selectedLevel = (0,helpers/* geneateSelectedOptions */.jc)(courseLevel, searchQuery.crlvl, "slug", "child"); //set selected and expand

      setCheckedState(function (prevState) {
        var _selectedLevel$expand, _selectedLevel$select;

        return _objectSpread(_objectSpread({}, prevState), {}, {
          expandedLevels: (_selectedLevel$expand = selectedLevel.expandOptions) !== null && _selectedLevel$expand !== void 0 ? _selectedLevel$expand : [],
          checkedLevels: (_selectedLevel$select = selectedLevel.selectedOptions) !== null && _selectedLevel$select !== void 0 ? _selectedLevel$select : []
        });
      }); //set serach level data

      setLevelArray(courseLevelData);
    } else {
      setLevelArray([]);
    }
  };

  (0,react.useEffect)(function () {
    generateLevels();
  }, [courseLevel]); //generate Levels

  var generateSpecializations = function generateSpecializations() {
    if (specialization && specialization.length > 0) {
      var spData = (0,helpers/* generateOptions */.uu)(specialization, "label", "slug", "children"); //set specialization data array

      setSpArray(spData); //generate selected specialization

      var selectedSpl = (0,helpers/* geneateSelectedOptions */.jc)(specialization, searchQuery.sp, "slug", "children"); //set selected and expand

      setCheckedState(function (prevState) {
        var _selectedSpl$expandOp, _selectedSpl$selected;

        return _objectSpread(_objectSpread({}, prevState), {}, {
          expandedSpecializations: (_selectedSpl$expandOp = selectedSpl.expandOptions) !== null && _selectedSpl$expandOp !== void 0 ? _selectedSpl$expandOp : [],
          checkedSpecializations: (_selectedSpl$selected = selectedSpl.selectedOptions) !== null && _selectedSpl$selected !== void 0 ? _selectedSpl$selected : []
        });
      });
    } else {
      setSpArray([]);
    }
  };

  (0,react.useEffect)(function () {
    generateSpecializations();
  }, [specialization]); //Genreate Exams Type

  var generateExamType = function generateExamType() {
    if (examType && examType.length > 0) {
      var spData = (0,helpers/* generateOptions */.uu)(examType, "label", "slug");
      setExamArray(spData); //generate selected specialization

      var selectedEx = (0,helpers/* geneateSelectedOptions */.jc)(examType, searchQuery.ex, "slug", "children"); //set selected and expand

      setCheckedState(function (prevState) {
        var _selectedEx$expandOpt, _selectedEx$selectedO;

        return _objectSpread(_objectSpread({}, prevState), {}, {
          expandedExam: (_selectedEx$expandOpt = selectedEx.expandOptions) !== null && _selectedEx$expandOpt !== void 0 ? _selectedEx$expandOpt : [],
          checkedExam: (_selectedEx$selectedO = selectedEx.selectedOptions) !== null && _selectedEx$selectedO !== void 0 ? _selectedEx$selectedO : []
        });
      });
    } else {
      setExamArray([]);
    }
  };

  (0,react.useEffect)(function () {
    generateExamType();
  }, [examType]); //Search Locations

  var searchLocations = function searchLocations(value) {
    setCheckedState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        checkedLocations: value
      });
    }); // expandedLocations

    var contries = [];
    var states = []; // let cities = [];

    if (value.length > 0) {
      value.map(function (loc) {
        var locArr = loc.split("_");
        if (locArr[0]) contries.push(locArr[0]);
        if (locArr[1]) states.push(locArr[1]); // if (locArr[2]) cities.push(locArr[2]);
      });
    }

    setSearchQuery(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        co: Array.from(new Set(contries)),
        st: Array.from(new Set(states)),
        page: 1
      });
    });
  };

  var getLocationExpand = function getLocationExpand(value) {
    setCheckedState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        expandedLocations: value
      });
    });
  }; //Search Levels


  var searchLevels = function searchLevels(value) {
    setCheckedState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        checkedLevels: value
      });
    });
    setSearchQuery(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        crlvl: Array.from(new Set(value)),
        page: 1
      });
    });
  }; //search Specializations


  var searchSpcs = function searchSpcs(value) {
    setCheckedState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        checkedSpecializations: value
      });
    });
    var specArray = [];

    if (value.length > 0) {
      value.map(function (loc) {
        var splite_data = loc.split("_");
        specArray = specArray.concat(splite_data);
      });
    }

    setSearchQuery(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        sp: Array.from(new Set(specArray)),
        page: 1
      });
    });
  };

  var searchSpcsExpand = function searchSpcsExpand(value) {
    setCheckedState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        expandedSpecializations: value
      });
    });
  }; //Search Levels


  var searchExamtype = function searchExamtype(value) {
    setCheckedState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        checkedExam: value
      });
    });
    setSearchQuery(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        ex: Array.from(new Set(value))
      });
    });
  };

  var examtypeExpand = function examtypeExpand(value) {
    setCheckedState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        expandedExam: value
      });
    });
  }; //reset all content


  var resetAll = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              delete searchQuery.ex;
              delete searchQuery.co;
              delete searchQuery.ci;
              delete searchQuery.st;
              delete searchQuery.crlvl;
              delete searchQuery.sp;
              delete searchQuery.tfees;
              delete searchQuery.duration;
              searchQuery.page = 1;
              setSearchQuery(searchQuery); //unchecked selected

              setCheckedState({
                checkedLocations: [],
                expandedLocations: [],
                checkedLevels: [],
                expandedLevels: [],
                checkedSpecializations: [],
                expandedSpecializations: [],
                checkedExam: [],
                expandedExam: []
              }); //get filtered data

              _context.next = 13;
              return getFilterData();

            case 13:
              //window redirect
              // setTimeout(() => {
              //router push
              if (pageUrl) {
                router.push("".concat(pageUrl, "?").concat((0,utils/* objectToQueryString */.nZ)(searchQuery)));
              } else {
                router.push("/search?".concat((0,utils/* objectToQueryString */.nZ)(searchQuery)));
              } // }, 0);


            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function resetAll() {
      return _ref2.apply(this, arguments);
    };
  }(); //Initial laoding


  var is_mounted = false;
  (0,react.useEffect)(function () {
    //set filter result and pagination
    var page_total = filterResult.page_total,
        totalCourseCount = filterResult.totalCourseCount,
        total = filterResult.total,
        currentPage = filterResult.currentPage,
        limit = filterResult.limit,
        results = filterResult.results;
    setPagerOption({
      page_total: page_total,
      totalCourseCount: totalCourseCount,
      total: total,
      currentPage: currentPage,
      limit: limit
    }); //set course results

    setPageData(results !== null && results !== void 0 ? results : []); //is no course found

    if (!totalCourseCount || totalCourseCount < 1) {
      setNoDataFound(true);
    }
  }, [pageUrl]);
  (0,react.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var generateShowMore;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setLoading(true); // const controller = new AbortController();

                if (is_mounted) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 4;
                return getFilterData();

              case 4:
                //handle view More
                generateShowMore = function generateShowMore() {
                  if (searchQuery.st || searchQuery.ci || searchQuery.crlvl || searchQuery.sp || searchQuery.ex || searchQuery.tfees || searchQuery.duration) {
                    var filterLevelArray = [];

                    if (searchQuery.st && searchQuery.st.length > 0) {
                      filterLevelArray = [].concat((0,toConsumableArray/* default */.Z)(filterLevelArray), (0,toConsumableArray/* default */.Z)(searchQuery.st));
                    }

                    if (searchQuery.ci && searchQuery.ci.length > 0) {
                      filterLevelArray = [].concat((0,toConsumableArray/* default */.Z)(filterLevelArray), (0,toConsumableArray/* default */.Z)(searchQuery.ci));
                    }

                    if (searchQuery.crlvl && searchQuery.crlvl.length > 0) {
                      filterLevelArray = [].concat((0,toConsumableArray/* default */.Z)(filterLevelArray), (0,toConsumableArray/* default */.Z)(searchQuery.crlvl));
                    }

                    if (searchQuery.sp && searchQuery.sp.length > 0) {
                      filterLevelArray = [].concat((0,toConsumableArray/* default */.Z)(filterLevelArray), (0,toConsumableArray/* default */.Z)(searchQuery.sp));
                    }

                    if (searchQuery.ex && searchQuery.ex.length > 0) {
                      filterLevelArray = [].concat((0,toConsumableArray/* default */.Z)(filterLevelArray), (0,toConsumableArray/* default */.Z)(searchQuery.ex));
                    }

                    setNumfilter(filterLevelArray.length);

                    if (filterLevelArray && parseInt(filterLevelArray.length) > 20) {
                      setFilterCollaps(true);
                    } else {
                      setFilterCollaps(false);
                    }
                  }
                }; //call generate show more function


                generateShowMore(); //call generatedFilteredLocations

                generateFilteredLocation();

                if (pageUrl) {
                  router.push("".concat(pageUrl, "?").concat((0,utils/* objectToQueryString */.nZ)(searchQuery)));
                } else {
                  router.push("/search?".concat((0,utils/* objectToQueryString */.nZ)(searchQuery)));
                }

              case 8:
                return _context2.abrupt("return", setTimeout(setLoading(false), 1000));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function fetchData() {
        return _ref3.apply(this, arguments);
      };
    }();

    fetchData();
  }, [searchQuery, pagerOption === null || pagerOption === void 0 ? void 0 : pagerOption.currentPage]);

  var generateFilteredLocation = function generateFilteredLocation() {
    var filteredLocations = location.filter(function (item) {
      return searchQuery.co && searchQuery.co.includes(item.slug);
    });
    filteredLocations.map(function (item) {
      item.filteredState = item.state && item.state.filter(function (st) {
        return searchQuery.st && searchQuery.st.includes(st.slug);
      });
    });
    setFilteredLocations(filteredLocations);
  }; //Get Search filter Data


  var getFilterData = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return api/* default.get */.Z.get("/search?".concat((0,utils/* objectToQueryString */.nZ)(searchQuery))).then(function (response) {
                if (!response.error && response.data) {
                  var _response$data$filter = response.data.filterResult,
                      page_total = _response$data$filter.page_total,
                      totalCourseCount = _response$data$filter.totalCourseCount,
                      total = _response$data$filter.total,
                      currentPage = _response$data$filter.currentPage,
                      limit = _response$data$filter.limit,
                      results = _response$data$filter.results;
                  setPagerOption({
                    page_total: page_total,
                    totalCourseCount: totalCourseCount,
                    total: total,
                    currentPage: currentPage,
                    limit: limit
                  });
                  setPageData(results);
                }
              })["catch"](function (err) {});

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function getFilterData() {
      return _ref4.apply(this, arguments);
    };
  }(); //pagination handle


  var patinationHandler = function patinationHandler(event, page) {
    //update page on serach query
    setSearchQuery(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        page: page
      });
    });
  }; //remove filter item


  var handleRemoveFilter = function handleRemoveFilter(filterType, slug) {
    setLoading(true);

    if (filterType == "co") {
      var newLocations = filteredLocations.filter(function (co) {
        return co.slug != slug;
      });
      var country = [];
      var state = [];
      newLocations.map(function (co) {
        country.push(co.slug);

        if (co.filteredState && co.filteredState.length > 0) {
          co.filteredState.map(function (st) {
            state.push(st.slug);
          });
        }
      });
      setSearchQuery(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          co: Array.from(new Set(country)),
          st: Array.from(new Set(state))
        });
      });
      return true;
    }

    if (filterType == "st") {
      var _filteredCountry$stat;

      var searchCountry = (0,toConsumableArray/* default */.Z)(searchQuery.co);

      var filteredCountry = location.filter(function (_ref5) {
        var state = _ref5.state;
        return state.filter(function (st) {
          return st.slug == slug;
        }).length > 0;
      })[0];
      var ActiveCountryState = filteredCountry === null || filteredCountry === void 0 ? void 0 : (_filteredCountry$stat = filteredCountry.state) === null || _filteredCountry$stat === void 0 ? void 0 : _filteredCountry$stat.filter(function (state) {
        var _searchQuery$st;

        return state.slug !== slug && ((_searchQuery$st = searchQuery.st) === null || _searchQuery$st === void 0 ? void 0 : _searchQuery$st.includes(state.slug));
      });

      if (!ActiveCountryState || ActiveCountryState.length == 0) {
        searchCountry = searchCountry.filter(function (item) {
          return item !== filteredCountry.slug;
        });
      }

      var states = searchQuery.st.filter(function (state) {
        return state !== slug;
      });
      setSearchQuery(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          co: Array.from(new Set(searchCountry)),
          st: Array.from(new Set(states))
        });
      });
      return true;
    }

    if (filterType == "crlvl") {
      var _courseLevel = (0,toConsumableArray/* default */.Z)(searchQuery.crlvl);

      var crlvl_states = _courseLevel.filter(function (level) {
        return level !== slug;
      });

      setSearchQuery(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          crlvl: Array.from(new Set(crlvl_states))
        });
      });
      return true;
    }

    if (filterType == "sp") {
      var courseSP = (0,toConsumableArray/* default */.Z)(searchQuery.sp);

      var sp_states = courseSP.filter(function (sp) {
        return sp !== slug;
      });
      setSearchQuery(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          sp: Array.from(new Set(sp_states))
        });
      });
      return true;
    }

    if (filterType == "ex") {
      var courseEX = (0,toConsumableArray/* default */.Z)(searchQuery.ex);

      var ex_states = courseEX.filter(function (ex) {
        return ex !== slug;
      });
      setSearchQuery(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          ex: Array.from(new Set(ex_states))
        });
      });
      return true;
    }
  }; //Search By Fees


  var searchByFees = function searchByFees(value) {
    setSearchQuery(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        tfees: value,
        page: 1
      });
    });
  }; //Search By Duration


  var searchByDuration = function searchByDuration(value) {
    setSearchQuery(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        duration: value,
        page: 1
      });
    });
  };

  var MoreBtn = function MoreBtn() {
    var lengthRemove = 0;
    filteredLocations.map(function (locat) {
      if (locat.filteredState.length === locat.state.length) {
        lengthRemove = lengthRemove + parseInt(locat.state.length) - 1;
      }
    });

    if (filterCollaps && parseInt(filterNum - lengthRemove) > 20) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: (search_filter_module_default()).moreBtn,
        onClick: function onClick(e) {
          setFilterCollaps(false);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: " More ..."
        })
      });
    }

    return "";
  }; // Left side content


  var LeftSide = function LeftSide() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (search_filter_module_default()).filter_title_reset,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (search_filter_module_default()).title,
          children: " Filters "
        }), (checkedState && checkedState.checkedLocations.length > 0 || checkedState && checkedState.checkedLevels.length > 0 || checkedState && checkedState.checkedSpecializations.length > 0 || checkedState && checkedState.checkedExam.length > 0) && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (search_filter_module_default()).reset,
          onClick: resetAll,
          children: "Reset All"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (search_filter_module_default()).filter_option_wrapper,
        children: [locationArray && locationArray.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "filter_location",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(advance/* FilterBoxCheckbox */.mf, {
            data: locationArray,
            onChange: searchLocations,
            getExpand: getLocationExpand,
            selected: checkedState.checkedLocations,
            expanded: checkedState.expandedLocations,
            title: "Location",
            search: true,
            loading: loading
          })
        }), levelArray && levelArray.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "filter_course_level",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(advance/* FilterBoxCheckbox */.mf, {
            onChange: searchLevels,
            data: levelArray,
            selected: checkedState.checkedLevels,
            title: "Course Level",
            loading: loading
          })
        }), spArray && spArray.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "filter_specialization",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(advance/* FilterBoxCheckbox */.mf, {
            onChange: searchSpcs,
            getExpand: searchSpcsExpand,
            selected: checkedState.checkedSpecializations,
            expanded: checkedState.expandedSpecializations,
            data: spArray,
            title: "Specialization",
            loading: loading
          })
        }), examArray && examArray.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "filter_exam",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(advance/* FilterBoxCheckbox */.mf, {
            data: examArray,
            onChange: searchExamtype,
            getExpand: examtypeExpand,
            expanded: checkedState.expandedExam,
            selected: checkedState.checkedExam,
            title: "Eligibility Exam",
            loading: loading
          })
        }), durationObj && durationObj.maxDuration > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(advance/* FilterBoxSlider */._k, {
          title: "Course Duration",
          range: [parseInt(durationObj.minDuration), parseInt(durationObj.maxDuration)],
          value: searchQuery !== null && searchQuery !== void 0 && searchQuery.duration && (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.duration.length) == 2 ? [parseInt(searchQuery.duration[0]), parseInt(searchQuery.duration[1])] : [parseInt(durationObj.minDuration), parseInt(durationObj.maxDuration)],
          onChange: searchByDuration,
          loading: loading,
          icon: "m",
          offset: "right"
        }), feesObj && parseInt(feesObj.maxAmount) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(advance/* FilterBoxSlider */._k, {
          title: "Tution Fees(First Year)",
          range: [parseInt(feesObj.minAmount), parseInt(feesObj.maxAmount)],
          value: searchQuery !== null && searchQuery !== void 0 && searchQuery.tfees && (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.tfees.length) == 2 ? [parseInt(searchQuery.tfees[0]), parseInt(searchQuery.tfees[1])] : [parseInt(feesObj.minAmount), parseInt(feesObj.maxAmount)],
          onChange: searchByFees,
          loading: loading,
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(bi_index_esm/* BiMoney */.iFN, {}),
          offset: "left"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (search_filter_module_default()).filter_all_btn_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "btn btn-outline btn-sm",
          onClick: resetAll,
          children: "Reset All"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "btn btn-primary btn-sm",
          onClick: function onClick() {
            return setDrawerOpen(false);
          },
          children: "Apply All Filters"
        })]
      })]
    });
  }; // Right side content


  var RightSide = function RightSide() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (search_filter_module_default()).uni_box_wrapper,
        children: [(loading ? Array.from(new Array(6)) : pageData).map(function (item, index) {
          if (item) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (search_filter_module_default()).thumb_box_desktop,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(uni_thumb_list_box/* default */.Z, {
                  item: item
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (search_filter_module_default()).thumb_box_mobile,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(uni_thumb_box_mobile/* default */.Z, {
                  item: item
                })
              }, "mob_search_".concat(index))]
            }, "search_".concat(index));
          } else {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(course_screen/* default */.Z, {}, "search_".concat(index));
          }
        }), !loading && pagerOption && pagerOption.total > 10 && /*#__PURE__*/(0,jsx_runtime.jsx)(pagination/* default */.Z, {
          paginate: pagerOption,
          paginationHandler: patinationHandler
        })]
      })
    });
  };

  if (!noDataFound) {
    var _searchQuery$sp;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
        className: (search_filter_module_default()).section_search_hero,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "container",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (search_filter_module_default()).hero_content_wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (search_filter_module_default()).search_result_text,
              children: [pagerOption && (pagerOption === null || pagerOption === void 0 ? void 0 : pagerOption.totalCourseCount), " ", (pagerOption === null || pagerOption === void 0 ? void 0 : pagerOption.totalCourseCount) > 1 ? "courses" : "course", " found in ", pagerOption && (pagerOption === null || pagerOption === void 0 ? void 0 : pagerOption.total), " ", (pagerOption === null || pagerOption === void 0 ? void 0 : pagerOption.total) > 1 ? "universities" : "University", " ", searchQuery !== null && searchQuery !== void 0 && searchQuery.refq || (searchQuery === null || searchQuery === void 0 ? void 0 : (_searchQuery$sp = searchQuery.sp) === null || _searchQuery$sp === void 0 ? void 0 : _searchQuery$sp.length) > 0 ? "for " : "", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: refq ? searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.refq : searchQuery !== null && searchQuery !== void 0 && searchQuery.sp ? (0,helpers/* slugToString */.Vl)(searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.sp) : ""
              })]
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
        className: (search_filter_module_default()).section_search_filter,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (search_filter_module_default()).filter_and_indector_wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (search_filter_module_default()).filter_btn_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                onClick: function onClick() {
                  return setDrawerOpen(true);
                },
                className: (search_filter_module_default()).btn_filter,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiFilter */.Ihx, {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "FIlter"
                })]
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (search_filter_module_default()).filter_buttons,
            children: [(filteredLocations && filteredLocations.length > 0 || searchQuery.crlvl && searchQuery.crlvl.length > 0 || searchQuery.sp && searchQuery.sp.length > 0 || searchQuery.ex && searchQuery.ex.length > 0) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "".concat((search_filter_module_default()).filter_indectors, " ").concat(filterCollaps ? (search_filter_module_default()).filter_Collapsable : (search_filter_module_default()).filter_expanded),
              children: [filteredLocations && filteredLocations.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
                children: filteredLocations.map(function (locat, index) {
                  if (locat.filteredState.length === locat.state.length) {
                    var _locat$name;

                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                      onClick: function onClick(e) {
                        handleRemoveFilter("co", locat.slug);
                      },
                      disabled: loading,
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: (_locat$name = locat.name) !== null && _locat$name !== void 0 ? _locat$name : ""
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: (search_filter_module_default()).close,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {})
                      })]
                    }, "filter_".concat(index));
                  } else {
                    var stateData = locat.filteredState && locat.filteredState.map(function (st, stindex) {
                      var _st$name;

                      return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                        onClick: function onClick(e) {
                          handleRemoveFilter("st", st.slug);
                        },
                        disabled: loading,
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          children: (_st$name = st.name) !== null && _st$name !== void 0 ? _st$name : ""
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          className: (search_filter_module_default()).close,
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {})
                        })]
                      }, "filter_".concat(index).concat(stindex));
                    });
                    return stateData;
                  }
                })
              }), searchQuery.st && searchQuery.st.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (search_filter_module_default()).filter_btngroup,
                children: searchQuery.st.map(function (stItem, index) {
                  var _slugToString;

                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                    onClick: function onClick(e) {
                      handleRemoveFilter("st", stItem);
                    },
                    disabled: loading,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: (_slugToString = (0,helpers/* slugToString */.Vl)(stItem)) !== null && _slugToString !== void 0 ? _slugToString : ""
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: (search_filter_module_default()).close,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {})
                    })]
                  }, "filter_".concat(index));
                })
              }), searchQuery.crlvl && searchQuery.crlvl.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
                children: searchQuery.crlvl.map(function (stItem, index) {
                  var _slugToString2;

                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                    onClick: function onClick(e) {
                      handleRemoveFilter("crlvl", stItem);
                    },
                    disabled: loading,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: (_slugToString2 = (0,helpers/* slugToString */.Vl)(stItem)) !== null && _slugToString2 !== void 0 ? _slugToString2 : ""
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: (search_filter_module_default()).close,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {})
                    })]
                  }, "filter_crlvl_".concat(index));
                })
              }), searchQuery.sp && searchQuery.sp.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
                children: searchQuery.sp.map(function (stItem, index) {
                  var _slugToString3;

                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                    onClick: function onClick(e) {
                      handleRemoveFilter("sp", stItem);
                    },
                    disabled: loading,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: (_slugToString3 = (0,helpers/* slugToString */.Vl)(stItem)) !== null && _slugToString3 !== void 0 ? _slugToString3 : ""
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: (search_filter_module_default()).close,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {})
                    })]
                  }, "filter_sp_".concat(index));
                })
              }), searchQuery.ex && searchQuery.ex.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
                children: searchQuery.ex.map(function (stItem, index) {
                  var _slugToString4;

                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                    onClick: function onClick(e) {
                      handleRemoveFilter("ex", stItem);
                    },
                    disabled: loading,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: (_slugToString4 = (0,helpers/* slugToString */.Vl)(stItem)) !== null && _slugToString4 !== void 0 ? _slugToString4 : ""
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: (search_filter_module_default()).close,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {})
                    })]
                  }, "filter_ex_".concat(index));
                })
              })]
            }), MoreBtn()]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "".concat((search_filter_module_default()).wrapper),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (search_filter_module_default()).filter_desktop,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LeftSide, {})
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(RightSide, {})]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SwipeableDrawer/* default */.Z, {
        anchor: "left",
        classes: {
          paper: "SearchFilterDrawer ".concat((search_filter_module_default()).search_filter_drawer)
        },
        open: drawerOpen,
        onClose: toggleDrawer(false),
        onOpen: toggleDrawer(true),
        disableSwipeToOpen: false,
        ModalProps: {
          keepMounted: true
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (search_filter_module_default()).filter_drawer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (search_filter_module_default()).filter_drawer_head,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (search_filter_module_default()).filter_title,
              children: "Filter Your Result"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {
              onClick: function onClick() {
                return setDrawerOpen(false);
              },
              className: (search_filter_module_default()).close_icon
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(LeftSide, {})]
        })
      })]
    });
  }

  var generalSearch = function generalSearch() {
    if (loading) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        style: {
          display: "grid",
          placeItems: "center",
          height: "50vh"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
      });
    } else {
      var _filterResult$results, _filterResult$results2;

      if (filterResult && (filterResult === null || filterResult === void 0 ? void 0 : (_filterResult$results = filterResult.results) === null || _filterResult$results === void 0 ? void 0 : _filterResult$results.length) === 1 && filterResult !== null && filterResult !== void 0 && filterResult.results[0].slug && (filterResult === null || filterResult === void 0 ? void 0 : (_filterResult$results2 = filterResult.results[0].course) === null || _filterResult$results2 === void 0 ? void 0 : _filterResult$results2.length) === 0) {
        var _filterResult$results3;

        router.push("/study/".concat(filterResult === null || filterResult === void 0 ? void 0 : (_filterResult$results3 = filterResult.results[0].country) === null || _filterResult$results3 === void 0 ? void 0 : _filterResult$results3.slug, "/university/").concat(filterResult === null || filterResult === void 0 ? void 0 : filterResult.results[0].slug));
      } else {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (search_filter_module_default()).soft_bg
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
            className: (search_filter_module_default()).section_noresult,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "container",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (search_filter_module_default()).noresult_text_wrapper,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
                  className: (search_filter_module_default()).noresult_title,
                  children: ["We did not find any results for ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " \"", refq !== null && refq !== void 0 ? refq : searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.refq, "\""]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (search_filter_module_default()).noresult_sub_text,
                  children: "Click here to begin your search again."
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                  type: "button",
                  onClick: function onClick() {
                    return router.push("/");
                  },
                  className: "btn btn-secondary btn-bg ".concat((search_filter_module_default()).noresult_btn),
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiArrowLeft */.Ao2, {
                    style: {
                      fontSize: "18px"
                    }
                  }), " Back to Home"]
                })]
              })
            })
          })]
        });
      }
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: generalSearch()
  });
};
/* harmony default export */ var search_filter = ((0,next_router.withRouter)(SearchFilter));
;// CONCATENATED MODULE: ./_modules/study/search/index.js



/***/ }),

/***/ 74155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E6": function() { return /* reexport */ DownloadGuide; },
  "qq": function() { return /* reexport */ MessageComponent; },
  "Dk": function() { return /* reexport */ PersonList; },
  "sk": function() { return /* reexport */ common_form/* UniEditorSmall */.sk; },
  "z9": function() { return /* reexport */ useIsMount; }
});

// UNUSED EXPORTS: DatePickerComponent, DateRangeComponent, Dropdown, Editor, ImageInput, MultipleFileInput, PersonProfile, TimePeriod, Title, UniEditor, UniEditorDefault, UniEditorMedium, UniSugessions

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/title.jsx




var Title = function Title(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.heading,
    children: [title && /*#__PURE__*/_jsx("h3", {
      children: title
    }), subtitle && /*#__PURE__*/_jsx("p", {
      children: subtitle
    })]
  });
};
/* harmony default export */ var title = ((/* unused pure expression or super */ null && (Title)));
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/dropdown.jsx


var _excluded = (/* unused pure expression or super */ null && (["topLabel", "bottomLabel", "options", "placeholder", "className", "selectedValue", "inputId", "onChange", "register"]));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Dropdown = function Dropdown(_ref) {
  var topLabel = _ref.topLabel,
      bottomLabel = _ref.bottomLabel,
      options = _ref.options,
      placeholder = _ref.placeholder,
      className = _ref.className,
      selectedValue = _ref.selectedValue,
      inputId = _ref.inputId,
      _onChange = _ref.onChange,
      register = _ref.register,
      rest = _objectWithoutProperties(_ref, _excluded);

  // const [value, setValue] = useState("");
  // useEffect(() => {
  //   setValue(selectedValue);
  // }, [selectedValue]);
  // const handleChange = (e) => {
  //   const { label, value } = e;
  //   setValue(value);
  //   if (onChange) {
  //     onChange(e);
  //   }
  // };
  var customStyles = {
    control: function control(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, _defineProperty({
        height: "50px",
        boxShadow: " 0px 2px 5px rgba(38, 51, 77, 0.03)",
        borderColor: "none",
        "&:hover": {
          borderColor: "none"
        }
      }, "borderColor", state.isFocused ? "#e0e0e0" : "#e0e0e0"));
    },
    option: function option(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        cursor: "pointer",
        color: state.isSelected ? "#F47F20" : "#B5B5C3",
        backgroundColor: state.isSelected ? "#F5F6FC" : state.isFocused ? "#fff" : provided.backgroundColor,
        "&:hover": {
          backgroundColor: "#F5F6FC",
          color: "#F47F20"
        }
      });
    },
    menuPortal: function menuPortal(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        zIndex: 9999
      });
    }
  };
  return /*#__PURE__*/_jsxs(FormControl, {
    fullWidth: true,
    children: [topLabel && /*#__PURE__*/_jsx("label", {
      className: topLabel === "transparent" && styles.transparent,
      children: topLabel
    }), /*#__PURE__*/_jsx(Select, _defineProperty({
      className: "".concat(styles.select_input, " ").concat(className),
      options: options,
      onChange: _onChange,
      placeholder: placeholder && placeholder,
      styles: customStyles
    }, "onChange", function onChange(val) {
      return _onChange(val.value);
    })), bottomLabel && /*#__PURE__*/_jsx("label", {
      children: bottomLabel
    })]
  });
};
/* harmony default export */ var dropdown = ((/* unused pure expression or super */ null && (Dropdown)));
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/useIsMount.jsx

var useIsMount = function useIsMount() {
  var isMountRef = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    isMountRef.current = false;
  }, []);
  return isMountRef.current;
};
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/index.js



// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton_IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(1890);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(77745);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(95398);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardHeader/CardHeader.js + 1 modules
var CardHeader = __webpack_require__(59742);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(76779);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment_moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment_moment);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-icons/cg/index.esm.js
var cg_index_esm = __webpack_require__(80471);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./node_modules/react-timeago/es6/index.js
var es6 = __webpack_require__(92042);
// EXTERNAL MODULE: ./_unisearch/common/chatbox/person_list/list.module.scss
var list_module = __webpack_require__(6867);
var list_module_default = /*#__PURE__*/__webpack_require__.n(list_module);
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/person_list/index.jsx



/* eslint-disable @next/next/no-img-element */

















var PersonList = function PersonList(_ref) {
  var _connectedUserList$so;

  var data = _ref.data,
      clickHandler = _ref.clickHandler,
      chatId = _ref.chatId,
      setCurrentChat = _ref.setCurrentChat,
      socket = _ref.socket,
      connectedUserList = _ref.connectedUserList,
      getConnectedUserList = _ref.getConnectedUserList,
      loading = _ref.loading,
      setLoading = _ref.setLoading,
      customClasses = _ref.customClasses,
      closeDrawer = _ref.closeDrawer;

  var _useState = (0,react.useState)(),
      activeProfile = _useState[0],
      setActiveProfile = _useState[1];

  var _useState2 = (0,react.useState)(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      userList = _useState3[0],
      setUserList = _useState3[1];

  var router = (0,next_router.useRouter)(); // open chat box

  var handleClick = function handleClick(person) {
    if (clickHandler) clickHandler(person);
  };

  var handleOpen = function handleOpen() {
    setOpen(true);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  }; // get university list to add into friend list


  var getUserList = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(keyword) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (keyword && keyword.length >= 2 && keyword != "") {
                setLoading(true);
                setTimeout( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                  return regenerator_default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return api/* default.get */.Z.get("/chat-service/get-users/".concat(keyword)).then(function (res) {
                            if (!res.error) {
                              setUserList(res.data);
                              setLoading(false);
                            }
                          });

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })), 2000);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getUserList(_x) {
      return _ref2.apply(this, arguments);
    };
  }(); // add user into chat list


  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(payload) {
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return api/* default.post */.Z.post("/chat-service/add-user", {
                recieverId: parseInt((payload === null || payload === void 0 ? void 0 : payload.userTypeSlug) === "mentor" ? payload === null || payload === void 0 ? void 0 : payload.id : payload === null || payload === void 0 ? void 0 : payload.universityId),
                recieverType: payload === null || payload === void 0 ? void 0 : payload.userTypeSlug,
                senderTime: new Date()
              }).then( /*#__PURE__*/function () {
                var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(res) {
                  var _res$data;

                  return regenerator_default().wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (res.error) {
                            _context3.next = 7;
                            break;
                          }

                          handleClose();
                          _context3.next = 4;
                          return getConnectedUserList();

                        case 4:
                          setUserList([]);
                          setActiveProfile();
                          router.push("/app/student/messages?chatId=".concat((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.uid));

                        case 7:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x3) {
                  return _ref5.apply(this, arguments);
                };
              }());

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleSubmit(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((list_module_default()).list_wrapper, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (list_module_default()).header_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          className: "btn btn-sm btn-outline-grey ".concat((list_module_default()).btn_add_user),
          onClick: handleOpen,
          children: "New User"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Close/* default */.Z, {
          className: (list_module_default()).btn_close,
          onClick: closeDrawer
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(IconButton_IconButton/* default */.Z, {
          onClick: handleOpen,
          className: "".concat((list_module_default()).btn_plus, " relative"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "uni-tooltip",
            children: "New User"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (list_module_default()).chatt_box_wrapper,
        children: connectedUserList && (connectedUserList === null || connectedUserList === void 0 ? void 0 : connectedUserList.length) > 0 && (connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$so = connectedUserList.sort(function (a, b) {
          var _b$recentMsg, _b$recentMsg$chat_ser, _a$recentMsg;

          return b === null || b === void 0 ? void 0 : (_b$recentMsg = b.recentMsg) === null || _b$recentMsg === void 0 ? void 0 : (_b$recentMsg$chat_ser = _b$recentMsg.chat_service_message_senderTime) === null || _b$recentMsg$chat_ser === void 0 ? void 0 : _b$recentMsg$chat_ser.localeCompare(a === null || a === void 0 ? void 0 : (_a$recentMsg = a.recentMsg) === null || _a$recentMsg === void 0 ? void 0 : _a$recentMsg.chat_service_message_senderTime);
        })) === null || _connectedUserList$so === void 0 ? void 0 : _connectedUserList$so.map(function (item, index) {
          var _item$receiver, _item$receiver$name, _item$receiver2, _item$receiver3, _item$receiver4, _item$receiver5, _item$receiver6, _item$recentMsg, _item$recentMsg2, _item$recentMsg3;

          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              handleClick(item);
              setCurrentChat(item === null || item === void 0 ? void 0 : item.receiver);
              setActiveProfile(item);

              if (closeDrawer) {
                closeDrawer();
              }
            },
            className: item && (item === null || item === void 0 ? void 0 : item.uid) == chatId ? (list_module_default()).active_chatt_box : (list_module_default()).chatt_box,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (list_module_default()).chatt,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).image_wrapper,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  style: (item === null || item === void 0 ? void 0 : (_item$receiver = item.receiver) === null || _item$receiver === void 0 ? void 0 : _item$receiver.userTypeSlug) === "university" ? {
                    objectFit: "contain"
                  } : {},
                  alt: (_item$receiver$name = item === null || item === void 0 ? void 0 : (_item$receiver2 = item.receiver) === null || _item$receiver2 === void 0 ? void 0 : _item$receiver2.name) !== null && _item$receiver$name !== void 0 ? _item$receiver$name : "",
                  src: item !== null && item !== void 0 && (_item$receiver3 = item.receiver) !== null && _item$receiver3 !== void 0 && _item$receiver3.media ? (item === null || item === void 0 ? void 0 : (_item$receiver4 = item.receiver) === null || _item$receiver4 === void 0 ? void 0 : _item$receiver4.media) === null ? (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png") : item === null || item === void 0 ? void 0 : (_item$receiver5 = item.receiver) === null || _item$receiver5 === void 0 ? void 0 : _item$receiver5.media : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png")
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (list_module_default()).chatt_msg,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                    children: item === null || item === void 0 ? void 0 : (_item$receiver6 = item.receiver) === null || _item$receiver6 === void 0 ? void 0 : _item$receiver6.name
                  }), item !== null && item !== void 0 && item.recentMsg ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: item === null || item === void 0 ? void 0 : (_item$recentMsg = item.recentMsg) === null || _item$recentMsg === void 0 ? void 0 : _item$recentMsg.chat_service_message_messages
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: "You Are Connected"
                  })]
                }), (item === null || item === void 0 ? void 0 : (_item$recentMsg2 = item.recentMsg) === null || _item$recentMsg2 === void 0 ? void 0 : _item$recentMsg2.chat_service_message_createdAt) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (list_module_default()).time,
                  children: moment_default()(item === null || item === void 0 ? void 0 : (_item$recentMsg3 = item.recentMsg) === null || _item$recentMsg3 === void 0 ? void 0 : _item$recentMsg3.chat_service_message_senderTime).fromNow()
                })]
              })]
            })
          }, "plist_".concat(index, "_").concat(item.id));
        }))
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
      open: open,
      onClose: handleClose,
      sx: {
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "600px",
            paddingRight: "2px"
          }
        }
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DialogTitle/* default */.Z, {
        children: ["Start a New Chat", /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
          "aria-label": "close",
          onClick: handleClose,
          sx: {
            position: "absolute",
            right: 8,
            top: 12,
            color: function color(theme) {
              return theme.palette.grey[500];
            }
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(cg_index_esm/* CgClose */.Fk5, {})
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
        dividers: true,
        sx: {
          padding: "0",
          minHeight: "50vh",
          maxHeight: "50vh"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (list_module_default()).search_input_modal,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            autoFocus: true,
            onChange: function onChange(e) {
              getUserList(e.target.value);
            },
            type: "text",
            placeholder: "Search User"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiSearch */.jRj, {
            className: (list_module_default()).search_icon,
            style: {
              fontSize: "20px"
            }
          })]
        }), userList && (userList === null || userList === void 0 ? void 0 : userList.length) > 0 && !loading && (userList === null || userList === void 0 ? void 0 : userList.map(function (item, i) {
          var _item$fullName;

          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              setActiveProfile(item);
            },
            className: activeProfile && activeProfile.email === item.email ? (list_module_default()).active_chatt_box_modal : (list_module_default()).chatt_box,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (list_module_default()).chatt,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).image_wrapper,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: item.mediaSrc ? item.mediaSrc : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png"),
                  alt: (_item$fullName = item.fullName) !== null && _item$fullName !== void 0 ? _item$fullName : ""
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).chatt_msg,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [(item === null || item === void 0 ? void 0 : item.fullName) && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                    style: {
                      textTransform: "capitalize"
                    },
                    children: item === null || item === void 0 ? void 0 : item.fullName
                  }), (item === null || item === void 0 ? void 0 : item.email) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                    children: [item === null || item === void 0 ? void 0 : item.email, " (", item === null || item === void 0 ? void 0 : item.userTypeSlug, ")"]
                  })]
                })
              })]
            })
          }, "plist_".concat(i));
        })), loading && Array(6).fill().map(function (item, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
            sx: {
              maxWidth: "100%",
              padding: "0 15px",
              margin: "-16px 0",
              boxShadow: "none"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
              avatar: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
                animation: "wave",
                variant: "circular",
                width: 40,
                height: 40
              }),
              title: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
                animation: "wave",
                height: 10,
                width: "80%",
                style: {
                  marginBottom: 6
                }
              }),
              subheader: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
                animation: "wave",
                height: 10,
                width: "40%"
              })
            })
          }, i);
        }), (userList === null || userList === void 0 ? void 0 : userList.length) === 0 && !loading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (list_module_default()).no_found,
          children: "No User Found"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
        sx: {
          padding: "12px 20px"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "btn btn-cancel btn-md",
          onClick: handleClose,
          children: "Cancel"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return handleSubmit(activeProfile);
          },
          type: "submit",
          className: "btn btn-secondary btn-md",
          style: {
            minWidth: "82px"
          },
          children: "Add"
        })]
      })]
    })]
  });
};
/* harmony default export */ var person_list = ((/* unused pure expression or super */ null && (PersonList)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-icons/tfi/index.esm.js
var tfi_index_esm = __webpack_require__(81873);
// EXTERNAL MODULE: ./node_modules/react-scroll-to-bottom/lib/esm/index.js + 56 modules
var esm = __webpack_require__(17352);
// EXTERNAL MODULE: ./_unisearch/common/chatbox/message_component/message.module.scss
var message_module = __webpack_require__(42891);
var message_module_default = /*#__PURE__*/__webpack_require__.n(message_module);
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/message_component/index.jsx




/* eslint-disable @next/next/no-img-element */













var MessageComponent = function MessageComponent(_ref) {
  var _messages$, _connectedUserList$fi6, _connectedUserList$fi7, _myMessages$replace;

  var profileInfo = _ref.profileInfo,
      messages = _ref.messages,
      setMessages = _ref.setMessages,
      scrolref = _ref.scrolref,
      _ref$currentChat = _ref.currentChat,
      currentChat = _ref$currentChat === void 0 ? (_messages$ = messages[0]) === null || _messages$ === void 0 ? void 0 : _messages$.receiver : _ref$currentChat,
      getConnectedUserList = _ref.getConnectedUserList,
      _ref$connectedUserLis = _ref.connectedUserList,
      connectedUserList = _ref$connectedUserLis === void 0 ? false : _ref$connectedUserLis,
      chatId = _ref.chatId,
      socket = _ref.socket,
      setArrivalMessage = _ref.setArrivalMessage,
      closeDrawer = _ref.closeDrawer,
      openDrawer = _ref.openDrawer;

  //message state
  var _useState = (0,react.useState)(""),
      myMessages = _useState[0],
      setMyMessages = _useState[1];

  var _useState2 = (0,react.useState)(""),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var addNewLineToTextArea = function addNewLineToTextArea() {
    var msg_text = myMessages + "\r\n";
    setMyMessages(msg_text);
  }; //when press enter send message


  var handleKeyPress = function handleKeyPress(e) {
    var _e$target$value, _e$target$value$repla;

    if (e.keyCode === 13 && e.shiftKey) {
      e.preventDefault();
      addNewLineToTextArea();
    } else if (e.keyCode === 13 && ((_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : (_e$target$value$repla = _e$target$value.replace(/\s/g, "")) === null || _e$target$value$repla === void 0 ? void 0 : _e$target$value$repla.length) >= 1 && !loading) {
      handleSubmitMessage();
    }
  }; // push new message


  var handleSubmitMessage = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var _connectedUserList$fi, _connectedUserList$fi2;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.next = 3;
              return api/* default.post */.Z.post("/chat-service/new-meessage", {
                uid: chatId,
                messages: myMessages,
                recieverId: connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$fi = connectedUserList.find(function (item) {
                  return (item === null || item === void 0 ? void 0 : item.uid) == chatId;
                })) === null || _connectedUserList$fi === void 0 ? void 0 : (_connectedUserList$fi2 = _connectedUserList$fi.receiver) === null || _connectedUserList$fi2 === void 0 ? void 0 : _connectedUserList$fi2.id,
                recieverType: "university",
                senderTime: new Date()
              }).then( /*#__PURE__*/function () {
                var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(res) {
                  var _connectedUserList$fi3, _connectedUserList$fi4, _connectedUserList$fi5;

                  return regenerator_default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!res.error) {
                            setMyMessages("");
                            getConnectedUserList();
                            setMessages(function (prev) {
                              var _res$data, _res$data2, _res$data3, _res$data4, _res$data5, _res$data6, _res$data7, _res$data8, _res$data9, _res$data10, _res$data11, _res$data12;

                              return [].concat((0,toConsumableArray/* default */.Z)(prev), [{
                                id: (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.id,
                                uid: (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.uid,
                                studentId: (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.studentId,
                                senderType: (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.senderType,
                                universityId: (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.universityId,
                                university: (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.university,
                                mentorId: (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.mentorId,
                                mentor: (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.mentor,
                                recieverType: (_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.recieverType,
                                messages: (_res$data10 = res.data) === null || _res$data10 === void 0 ? void 0 : _res$data10.messages,
                                createdAt: (_res$data11 = res.data) === null || _res$data11 === void 0 ? void 0 : _res$data11.createdAt,
                                senderTime: res === null || res === void 0 ? void 0 : (_res$data12 = res.data) === null || _res$data12 === void 0 ? void 0 : _res$data12.senderTime
                              }]);
                            });
                            setArrivalMessage(null);
                            socket.current.emit("send-message", {
                              senderId: profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.id,
                              receiverId: connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$fi3 = connectedUserList.find(function (item) {
                                return (item === null || item === void 0 ? void 0 : item.uid) == chatId;
                              })) === null || _connectedUserList$fi3 === void 0 ? void 0 : (_connectedUserList$fi4 = _connectedUserList$fi3.receiver) === null || _connectedUserList$fi4 === void 0 ? void 0 : (_connectedUserList$fi5 = _connectedUserList$fi4.id) === null || _connectedUserList$fi5 === void 0 ? void 0 : _connectedUserList$fi5.toString(),
                              text: myMessages,
                              senderTime: new Date()
                            });
                            setLoading(false);
                          } else {
                            setLoading(false);
                          }

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmitMessage() {
      return _ref2.apply(this, arguments);
    };
  }(); // rendar message


  var RenderMessage = function RenderMessage(msgData) {
    var _msgData$receiver, _msgData$receiver2, _msgData$receiver3;

    if ((msgData === null || msgData === void 0 ? void 0 : msgData.is_first) == 1) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "chat_time",
        style: {
          fontSize: "13px"
        },
        children: msgData === null || msgData === void 0 ? void 0 : msgData.messages
      });
    } else if (msgData && (msgData === null || msgData === void 0 ? void 0 : msgData.studentId) === (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.id) && (msgData === null || msgData === void 0 ? void 0 : msgData.senderType) === "student") {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (message_module_default()).my_msg_wrapper,
        children: [(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (message_module_default()).my_msg_time,
          children: [moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).fromNow(), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).format("hh:mm A")
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (message_module_default()).my_msg,
          children: [(0,helpers/* newLineText */.$m)(msgData === null || msgData === void 0 ? void 0 : msgData.messages), (msgData === null || msgData === void 0 ? void 0 : msgData.is_read) == 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkDoneOutline */.xOC, {
            className: (message_module_default()).mark
          })]
        })]
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (message_module_default()).buddy_msg_wrapper,
      children: [(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (message_module_default()).msg_time,
        children: [moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).fromNow(), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).format("hh:mm A")
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (message_module_default()).msg_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (message_module_default()).image_wrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            style: (msgData === null || msgData === void 0 ? void 0 : (_msgData$receiver = msgData.receiver) === null || _msgData$receiver === void 0 ? void 0 : _msgData$receiver.userTypeSlug) === "university" ? {
              objectFit: "contain"
            } : {},
            src: msgData !== null && msgData !== void 0 && (_msgData$receiver2 = msgData.receiver) !== null && _msgData$receiver2 !== void 0 && _msgData$receiver2.media ? msgData === null || msgData === void 0 ? void 0 : (_msgData$receiver3 = msgData.receiver) === null || _msgData$receiver3 === void 0 ? void 0 : _msgData$receiver3.media : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png"),
            alt: "avatar"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (message_module_default()).replymsg,
          children: (0,helpers/* newLineText */.$m)(msgData === null || msgData === void 0 ? void 0 : msgData.messages)
        })]
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (message_module_default()).message_component_wrapper,
    children: [currentChat && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (message_module_default()).heading,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(tfi_index_esm/* TfiMenu */.lrj, {
        className: (message_module_default()).heading_menu,
        onClick: openDrawer
      }), connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$fi6 = connectedUserList.find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.uid) == chatId;
      })) === null || _connectedUserList$fi6 === void 0 ? void 0 : (_connectedUserList$fi7 = _connectedUserList$fi6.receiver) === null || _connectedUserList$fi7 === void 0 ? void 0 : _connectedUserList$fi7.name]
    }), messages && currentChat ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.ZP, {
        className: (message_module_default()).conversation_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (message_module_default()).conversation_wrapper_child,
          children: messages && (messages === null || messages === void 0 ? void 0 : messages.length) > 0 && (messages === null || messages === void 0 ? void 0 : messages.map(function (msgData, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "chat_scroll",
              id: "chat_scroll",
              children: RenderMessage(msgData)
            }, (Math.random() + 1).toString(36).substring(7));
          }))
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (message_module_default()).msg_footer_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (message_module_default()).action,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (message_module_default()).left,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (message_module_default()).image_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                alt: "profile",
                src: profileInfo !== null && profileInfo !== void 0 && profileInfo.profileImageSrc ? profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.profileImageSrc : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png")
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
              "aria-label": "minimum height",
              style: {
                minHeight: "40px"
              },
              placeholder: "Reply Message...",
              value: myMessages !== null && myMessages !== void 0 ? myMessages : "",
              onChange: function onChange(e) {
                setMyMessages(e.target.value);
              },
              onKeyDown: function onKeyDown(e) {
                if (e.key === "Enter") {
                  e.preventDefault();
                }

                handleKeyPress(e);
              }
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (message_module_default()).action_btn,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
              disabled: (myMessages === null || myMessages === void 0 ? void 0 : (_myMessages$replace = myMessages.replace(/\s/g, "")) === null || _myMessages$replace === void 0 ? void 0 : _myMessages$replace.length) >= 1 ? false : true,
              onClick: handleSubmitMessage,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdSend */.D6S, {})
            })
          })]
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (message_module_default()).details_wrapper2,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (message_module_default()).empty_detail_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Select a chat or start a new conversation"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: openDrawer,
          className: "btn btn-outline-grey btn-sm",
          children: "Start"
        })]
      })
    })]
  });
};
/* harmony default export */ var message_component = ((/* unused pure expression or super */ null && (MessageComponent)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/person_profile/index.jsx




var person_profile_excluded = (/* unused pure expression or super */ null && (["data", "profileType"]));


function person_profile_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function person_profile_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? person_profile_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : person_profile_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable @next/next/no-img-element */














var customStyles = {
  control: function control(base, state) {
    var _objectSpread2;

    return person_profile_objectSpread(person_profile_objectSpread({}, base), {}, (_objectSpread2 = {
      minHeight: "46px",
      boxShadow: state.isFocused ? "none" : "none",
      borderColor: "none",
      "&:hover": {
        borderColor: "none"
      }
    }, (0,defineProperty/* default */.Z)(_objectSpread2, "borderColor", state.isFocused ? "#f5f8fa" : "#f5f8fa"), (0,defineProperty/* default */.Z)(_objectSpread2, "backgroundColor", "#f5f8fa"), (0,defineProperty/* default */.Z)(_objectSpread2, "fontSize", "14px"), _objectSpread2));
  },
  option: function option(provided, state) {
    return person_profile_objectSpread(person_profile_objectSpread({}, provided), {}, {
      cursor: "pointer",
      fontSize: "14px",
      transition: "all 0.3s",
      color: state.isSelected ? "#F47F20" : "#B5B5C3",
      backgroundColor: state.isSelected ? "#F5F6FC" : state.isFocused ? "#fff" : provided.backgroundColor,
      "&:hover": {
        backgroundColor: "#F5F6FC",
        color: "#F47F20"
      }
    });
  },
  menuList: function menuList(base) {
    return person_profile_objectSpread(person_profile_objectSpread({}, base), {}, {
      "::-webkit-scrollbar": {
        width: "5px",
        height: "6px",
        overflow: "visible",
        cursor: "pointer",
        background: "transparent",
        borderRadius: "10px"
      },
      "::-webkit-scrollbar-thumb": {
        background: "rgb(202, 202, 202)",
        borderRadius: "10px",
        cursor: "pointer"
      }
    });
  }
};
var PersonProfile = function PersonProfile(_ref) {
  var _data$name, _profileInfo$workingC, _profileInfo$preferen, _profileInfo$preferen2, _profileInfo$preferen3, _profileInfo$preferen4, _profileInfo$preferen5, _profileInfo$preferen6, _profileInfo$preferen7, _profileInfo$preferen8, _profileInfo$preferen9, _profileInfo$preferen10, _profileInfo$preferen11, _profileInfo$preferen12, _profileInfo$preferen13, _profileInfo$preferen14, _profileInfo$preferen15, _profileInfo$preferen16, _profileInfo$preferen17, _profileInfo$preferen18, _profileInfo$preferen19, _profileInfo$preferen20, _profileInfo$preferen21, _profileInfo$preferen22, _profileInfo$preferen23, _profileInfo$preferen24, _profileInfo$preferen25, _profileInfo$preferen26, _profileInfo$preferen27, _profileInfo$preferen28, _profileInfo$preferen29, _profileInfo$preferen30, _profileInfo$preferen31, _profileInfo$preferen32, _profileInfo$preferen33, _profileInfo$preferen34, _profileInfo$preferen35, _profileInfo$preferen36, _profileInfo$preferen37, _profileInfo$preferen38;

  var data = _ref.data,
      profileType = _ref.profileType,
      props = _objectWithoutProperties(_ref, person_profile_excluded);

  var tZone = getTimeZone();

  var _React$useState = React.useState(new Date()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _useState = useState(moment.tz.guess()),
      currentTzone = _useState[0],
      setCurrentTzone = _useState[1];

  var _useState2 = useState(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      showInMobile = _useState3[0],
      setShowInMobile = _useState3[1];

  var _useState4 = useState(),
      timeSlot = _useState4[0],
      setTimeslot = _useState4[1];

  var _useState5 = useState({}),
      profileInfo = _useState5[0],
      setProfileInfo = _useState5[1];

  var _useState6 = useState(),
      index = _useState6[0],
      setIndex = _useState6[1];

  var getProfile = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return API.get("/user/any-profile?userType=".concat(profileType, "&id=").concat(data === null || data === void 0 ? void 0 : data.id)).then(function (res) {
                if (!res.error) {
                  setProfileInfo(res.data);
                }
              })["catch"](function (error) {
                swalError("Something went wrong");
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getProfile() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (data !== null && data !== void 0 && data.id && profileType) {
      getProfile();
    }
  }, [data === null || data === void 0 ? void 0 : data.id, profileType]);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var payload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              payload = {
                date: value,
                counsellorId: data === null || data === void 0 ? void 0 : data.id,
                timezone: currentTzone
              };
              _context2.next = 3;
              return API.post("/student/counsellor-appointment/time-list", payload).then(function (res) {
                if (!res.error) {
                  setTimeslot(res.data);
                }
              })["catch"](function (error) {
                swalError("Something went wrong");
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (data !== null && data !== void 0 && data.id && value && currentTzone && profileType === "counsellor") {
      handleSubmit();
    }
  }, [data === null || data === void 0 ? void 0 : data.id, value, currentTzone, profileType]);

  function formatAMPM(time) {
    // return time;
    var hour = time.split(":");
    var hrs = parseInt(hour[0]);
    var ampm = hrs >= 12 ? "pm" : "am";
    hrs = hrs % 12;
    hrs = hrs ? hrs : 12; // the hour '0' should be '12'

    var strTime = hrs + ":" + hour[1] + " " + ampm;
    return strTime;
  }

  var handleOpen = function handleOpen() {
    setOpen(true);
    document.body.classList.add("popOpen");
    handleSubmit();
  };

  var handleClose = function handleClose() {
    setOpen(false);
    document.body.classList.remove("popOpen");
    setIndex();
  };

  return /*#__PURE__*/_jsxs("div", {
    className: styles.profile_wrapper,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.image_wrapper,
      children: /*#__PURE__*/_jsx("img", {
        src: data.profileImage ? data.profileImage : getAssets("assets/student-avatar-big.png"),
        alt: (_data$name = data === null || data === void 0 ? void 0 : data.name) !== null && _data$name !== void 0 ? _data$name : ""
      })
    }), /*#__PURE__*/_jsx("h2", {
      children: data.name
    }), profileType && profileType == "counsellor" && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.profile_bio,
        children: [profileInfo && (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.bio) && htmlParse(profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.bio), profileInfo && (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.bio) && /*#__PURE__*/_jsx(Link, {
          legacyBehavior: true,
          href: "/app/student/counsellor/".concat(data === null || data === void 0 ? void 0 : data.id),
          children: /*#__PURE__*/_jsx("a", {
            className: styles.read_more,
            children: "Read More"
          })
        })]
      }), (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.workingCountry) && /*#__PURE__*/_jsx("h5", {
        children: "Working Country"
      }), (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.workingCountry) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$workingC = profileInfo.workingCountry) === null || _profileInfo$workingC === void 0 ? void 0 : _profileInfo$workingC.length) > 0 && /*#__PURE__*/_jsx("div", {
        className: styles.country_wrapper,
        children: profileInfo.workingCountry && profileInfo.workingCountry.map(function (item, i) {
          return /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: item
          }, i);
        })
      }), /*#__PURE__*/_jsx("button", {
        onClick: handleOpen,
        className: "btn btn-primary ".concat(styles.book_appiontment),
        children: "Book Appointment"
      })]
    }), profileType && profileType == "student" && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen = profileInfo.preferences) === null || _profileInfo$preferen === void 0 ? void 0 : _profileInfo$preferen.courselevel) && /*#__PURE__*/_jsx("h5", {
          children: "Course Level"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen2 = profileInfo.preferences) === null || _profileInfo$preferen2 === void 0 ? void 0 : (_profileInfo$preferen3 = _profileInfo$preferen2.courselevel) === null || _profileInfo$preferen3 === void 0 ? void 0 : _profileInfo$preferen3.levelName) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen4 = profileInfo.preferences) === null || _profileInfo$preferen4 === void 0 ? void 0 : (_profileInfo$preferen5 = _profileInfo$preferen4.courselevel) === null || _profileInfo$preferen5 === void 0 ? void 0 : _profileInfo$preferen5.levelName
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen6 = profileInfo.preferences) === null || _profileInfo$preferen6 === void 0 ? void 0 : _profileInfo$preferen6.countryPreferences) && /*#__PURE__*/_jsx("h5", {
          children: "Country Preferences"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen7 = profileInfo.preferences) === null || _profileInfo$preferen7 === void 0 ? void 0 : _profileInfo$preferen7.countryPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen8 = profileInfo.preferences) === null || _profileInfo$preferen8 === void 0 ? void 0 : (_profileInfo$preferen9 = _profileInfo$preferen8.countryPreferences) === null || _profileInfo$preferen9 === void 0 ? void 0 : _profileInfo$preferen9.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen10 = profileInfo.preferences) === null || _profileInfo$preferen10 === void 0 ? void 0 : _profileInfo$preferen10.countryPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen11 = profileInfo.preferences) === null || _profileInfo$preferen11 === void 0 ? void 0 : (_profileInfo$preferen12 = _profileInfo$preferen11.countryPreferences) === null || _profileInfo$preferen12 === void 0 ? void 0 : _profileInfo$preferen12.map(function (item, i) {
            return /*#__PURE__*/_jsx("h6", {
              className: styles.country,
              children: item
            }, i);
          }))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen13 = profileInfo.preferences) === null || _profileInfo$preferen13 === void 0 ? void 0 : _profileInfo$preferen13.studyPreferences) && /*#__PURE__*/_jsx("h5", {
          children: "Preferred Courses"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen14 = profileInfo.preferences) === null || _profileInfo$preferen14 === void 0 ? void 0 : _profileInfo$preferen14.studyPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen15 = profileInfo.preferences) === null || _profileInfo$preferen15 === void 0 ? void 0 : (_profileInfo$preferen16 = _profileInfo$preferen15.studyPreferences) === null || _profileInfo$preferen16 === void 0 ? void 0 : _profileInfo$preferen16.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen17 = profileInfo.preferences) === null || _profileInfo$preferen17 === void 0 ? void 0 : _profileInfo$preferen17.studyPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen18 = profileInfo.preferences) === null || _profileInfo$preferen18 === void 0 ? void 0 : (_profileInfo$preferen19 = _profileInfo$preferen18.studyPreferences) === null || _profileInfo$preferen19 === void 0 ? void 0 : _profileInfo$preferen19.map(function (item, i) {
            return /*#__PURE__*/_jsx("h6", {
              className: styles.country,
              children: item
            }, i);
          }))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen20 = profileInfo.preferences) === null || _profileInfo$preferen20 === void 0 ? void 0 : _profileInfo$preferen20.specialization) && /*#__PURE__*/_jsx("h5", {
          children: "Specialization"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen21 = profileInfo.preferences) === null || _profileInfo$preferen21 === void 0 ? void 0 : (_profileInfo$preferen22 = _profileInfo$preferen21.specialization) === null || _profileInfo$preferen22 === void 0 ? void 0 : _profileInfo$preferen22.specializationName) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen23 = profileInfo.preferences) === null || _profileInfo$preferen23 === void 0 ? void 0 : (_profileInfo$preferen24 = _profileInfo$preferen23.specialization) === null || _profileInfo$preferen24 === void 0 ? void 0 : _profileInfo$preferen24.specializationName
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen25 = profileInfo.preferences) === null || _profileInfo$preferen25 === void 0 ? void 0 : _profileInfo$preferen25.intakePreferences) && /*#__PURE__*/_jsx("h5", {
          children: "Intake"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen26 = profileInfo.preferences) === null || _profileInfo$preferen26 === void 0 ? void 0 : _profileInfo$preferen26.intakePreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen27 = profileInfo.preferences) === null || _profileInfo$preferen27 === void 0 ? void 0 : (_profileInfo$preferen28 = _profileInfo$preferen27.intakePreferences) === null || _profileInfo$preferen28 === void 0 ? void 0 : _profileInfo$preferen28.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen29 = profileInfo.preferences) === null || _profileInfo$preferen29 === void 0 ? void 0 : _profileInfo$preferen29.intakePreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen30 = profileInfo.preferences) === null || _profileInfo$preferen30 === void 0 ? void 0 : (_profileInfo$preferen31 = _profileInfo$preferen30.intakePreferences) === null || _profileInfo$preferen31 === void 0 ? void 0 : _profileInfo$preferen31.map(function (item, i) {
            var year = item.year,
                data = item.data;
            var last = Object.keys(data).length - 1;
            var payload = {
              year: year,
              from: data[Object.keys(data)[0]],
              to: data[Object.keys(data)[last]]
            };
            return /*#__PURE__*/_jsx("h6", {
              className: styles.country,
              children: "".concat(payload.from, "-").concat(payload.to, ", ").concat(payload.year)
            }, i);
          }))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen32 = profileInfo.preferences) === null || _profileInfo$preferen32 === void 0 ? void 0 : _profileInfo$preferen32.budget) && /*#__PURE__*/_jsx("h5", {
          children: "Budget"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen33 = profileInfo.preferences) === null || _profileInfo$preferen33 === void 0 ? void 0 : _profileInfo$preferen33.budget) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen34 = profileInfo.preferences) === null || _profileInfo$preferen34 === void 0 ? void 0 : _profileInfo$preferen34.budget
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen35 = profileInfo.preferences) === null || _profileInfo$preferen35 === void 0 ? void 0 : _profileInfo$preferen35.objective) && /*#__PURE__*/_jsx("h5", {
          children: "Objective"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen36 = profileInfo.preferences) === null || _profileInfo$preferen36 === void 0 ? void 0 : _profileInfo$preferen36.objective) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen37 = profileInfo.preferences) === null || _profileInfo$preferen37 === void 0 ? void 0 : (_profileInfo$preferen38 = _profileInfo$preferen37.objective) === null || _profileInfo$preferen38 === void 0 ? void 0 : _profileInfo$preferen38.objectivePurpose
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      open: open,
      onClose: handleClose,
      closeAfterTransition: true,
      BackdropComponent: Backdrop,
      BackdropProps: {
        timeout: 500
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "modal ".concat(styles.modal_custom_width),
        children: [/*#__PURE__*/_jsx("button", {
          className: "".concat(styles.cross_icon, " cross_icon"),
          onClick: handleClose,
          children: /*#__PURE__*/_jsx(FiX, {})
        }), /*#__PURE__*/_jsx("div", {
          className: styles.appoint_modal,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.appoint_modal_right,
            children: [/*#__PURE__*/_jsx("h3", {
              className: styles.appoint_title,
              children: "Select a Date & Time"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.appoint_calender_and_time_wrapper,
              children: [/*#__PURE__*/_jsxs("div", {
                className: "".concat(styles.calender_and_time_zone_wrapper, " ").concat(showInMobile ? styles.active : ""),
                children: [/*#__PURE__*/_jsx("div", {
                  style: {
                    maxHeight: "310px"
                  },
                  children: /*#__PURE__*/_jsx(LocalizationProvider, {
                    dateAdapter: AdapterDateFns,
                    children: /*#__PURE__*/_jsx(StaticDatePicker, {
                      className: "appointModalDatePicker",
                      displayStaticWrapperAs: "desktop",
                      openTo: "day",
                      minDate: new Date(),
                      value: value,
                      onChange: function onChange(newValue) {
                        setValue(newValue);
                        setShowInMobile(true);
                        setIndex();
                      },
                      renderInput: function renderInput(params) {
                        return /*#__PURE__*/_jsx(TextField, person_profile_objectSpread({}, params));
                      }
                    })
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.time_zone_wrapper,
                  children: [/*#__PURE__*/_jsx("label", {
                    className: styles.label,
                    children: "Select Time Zone"
                  }), /*#__PURE__*/_jsx(Select, {
                    menuPlacement: "top",
                    placeholder: "Select Timezone",
                    styles: customStyles,
                    options: tZone,
                    value: currentTzone && tZone ? tZone.filter(function (tz) {
                      return tz.value == currentTzone;
                    }) : "",
                    onChange: function onChange(item) {
                      setCurrentTzone(item.value);
                      setIndex();
                    }
                  })]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "".concat(styles.appoint_time_wrapper, " ").concat(showInMobile ? styles.active : ""),
                children: [/*#__PURE__*/_jsxs("div", {
                  className: styles.back_icon_and_date_wrapper,
                  children: [/*#__PURE__*/_jsx(IconButton, {
                    onClick: function onClick() {
                      return setShowInMobile(false);
                    },
                    className: styles.back_btn,
                    children: /*#__PURE__*/_jsx(ArrowBackIcon, {})
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.appoint_time_title,
                    children: new Date(value).toDateString()
                  })]
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.appoint_time_list_wrapper,
                  children: /*#__PURE__*/_jsx("ul", {
                    children: timeSlot && timeSlot.length > 0 ? timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.map(function (item, i) {
                      return /*#__PURE__*/_jsxs("li", {
                        children: [/*#__PURE__*/_jsxs("button", {
                          onClick: function onClick() {
                            return setIndex(i);
                          },
                          className: "".concat(styles.appoint_time_btn, " ").concat(index === i ? styles.active : ""),
                          children: [formatAMPM(item === null || item === void 0 ? void 0 : item.startTime), "-", formatAMPM(item === null || item === void 0 ? void 0 : item.endTime)]
                        }), /*#__PURE__*/_jsx("button", {
                          className: "".concat(styles.confirm_btn, " ").concat(index === i ? styles.active : "", " btn btn-secondary btn-bg"),
                          onClick: function onClick() {
                            handleFormSubmit(item === null || item === void 0 ? void 0 : item.timeId);
                          },
                          children: "Confirm"
                        })]
                      }, i);
                    }) : /*#__PURE__*/_jsx("li", {
                      className: styles.no_record,
                      children: "\"No Appoinment Schedule\""
                    })
                  })
                })]
              })]
            })]
          })
        })]
      })
    })]
  });
};
/* harmony default export */ var person_profile = ((/* unused pure expression or super */ null && (PersonProfile)));
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/index.js



// EXTERNAL MODULE: ./_unisearch/common/form/index.js + 15 modules
var common_form = __webpack_require__(15603);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./_recoil/_actions/index.js + 5 modules
var _actions = __webpack_require__(8612);
// EXTERNAL MODULE: ./_recoil/_state/index.js + 9 modules
var _state = __webpack_require__(89093);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(93162);
;// CONCATENATED MODULE: ./_unisearch/common/download_guide/index.jsx


var download_guide_excluded = ["fileSrc", "btnTitle", "fileName", "documentType", "customClasses", "customStyles", "universityId", "documentId"];











/*
documentType -> 'prospectus', 'exam', 'document', 'course', 'ebook', 'countryguide'

This componetn takes props
-> fileSrc
-> fileName
-> btnTitle
-> documentType
-> universityId
-> documentId
-> customClasses={
        root.[your class name]
    }
-> customClasses={
        title.[your class name]
   }
-> customClasses={
        tooltip.[your class name]
    }
-> customStyles={{ root: { color: "blue" } }}
-> customStyles={{ title: { fontSize: "30px" } }}
-> customStyles={{ tooltip: { color: "blue" } }}
 */



var DownloadGuide = function DownloadGuide(_ref) {
  var fileSrc = _ref.fileSrc,
      btnTitle = _ref.btnTitle,
      fileName = _ref.fileName,
      _ref$documentType = _ref.documentType,
      documentType = _ref$documentType === void 0 ? "prospectus" : _ref$documentType,
      customClasses = _ref.customClasses,
      customStyles = _ref.customStyles,
      _ref$universityId = _ref.universityId,
      universityId = _ref$universityId === void 0 ? 0 : _ref$universityId,
      _ref$documentId = _ref.documentId,
      documentId = _ref$documentId === void 0 ? 0 : _ref$documentId,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, download_guide_excluded);

  var router = (0,next_router.useRouter)();
  var systemActions = (0,_actions/* useSystemActions */.x3)();
  var profileInfos = (0,recoil/* useRecoilValue */.sJ)(_state/* authAtom */.L4);

  var _useState = (0,react.useState)(),
      profileInfo = _useState[0],
      setProfileInfo = _useState[1];

  (0,react.useEffect)(function () {
    setProfileInfo(profileInfos);
  }, []);

  var storeStudentDownloadInfo = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return api/* default.post */.Z.post("/student/download-activity", {
                universityId: universityId,
                type: documentType,
                mediaId: documentId
              }).then(function (res) {});

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              (0,helpers/* swalError */.Kj)("Something went wrong");

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function storeStudentDownloadInfo() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleDownload = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(fileSrc) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (profileInfo) {
                _context2.next = 3;
                break;
              }

              systemActions.setReturnUrl(router.asPath);
              return _context2.abrupt("return", router.push({
                pathname: "/signin"
              }));

            case 3:
              if (profileInfo && profileInfo.userTypeSlug === "student") {
                storeStudentDownloadInfo();
              }

              window.open(fileSrc, "_blank");

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleDownload(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
    onClick: function onClick() {
      handleDownload(fileSrc);
    },
    className: "btn btn-secondary relative ".concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
    style: customStyles === null || customStyles === void 0 ? void 0 : customStyles.root,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdPictureAsPdf */.OY_, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "".concat(customClasses !== null && customClasses !== void 0 && customClasses.title ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.title : ""),
      style: customStyles === null || customStyles === void 0 ? void 0 : customStyles.title,
      children: btnTitle || "Download Brochure"
    }), !profileInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: "uni-tooltip ".concat(customClasses !== null && customClasses !== void 0 && customClasses.tooltip ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.tooltip : ""),
      style: customStyles === null || customStyles === void 0 ? void 0 : customStyles.tooltip,
      children: ["Please Login ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " to perform this action"]
    })]
  });
};
/* harmony default export */ var download_guide = ((/* unused pure expression or super */ null && (DownloadGuide)));
;// CONCATENATED MODULE: ./_unisearch/common/index.js





/***/ }),

/***/ 54650:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filter_option":"filter_box_checkbox_filter_option__NcRea","searach_wrapper":"filter_box_checkbox_searach_wrapper__m5aK4","searach_icon":"filter_box_checkbox_searach_icon__AVuNj","option_title_wrapper":"filter_box_checkbox_option_title_wrapper__VnZ2J","icon":"filter_box_checkbox_icon__VkJWc","filter_checkbox_wrapper":"filter_box_checkbox_filter_checkbox_wrapper__cwMFi"};

/***/ }),

/***/ 4644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filter_option":"filter_box_slider_filter_option__4nveH","option_title_wrapper":"filter_box_slider_option_title_wrapper__1t7go","currncy":"filter_box_slider_currncy__0CpNb","filter_slider_wrapper":"filter_box_slider_filter_slider_wrapper__iODVe","slider_range_text":"filter_box_slider_slider_range_text__RfE4d","slideContainer":"filter_box_slider_slideContainer__82VJv"};

/***/ }),

/***/ 40688:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uni_search_box":"uni_thumb_box_mobile_uni_search_box__xuprL","logo_uni_info_wrapper":"uni_thumb_box_mobile_logo_uni_info_wrapper__5aGvI","logo_wrapper":"uni_thumb_box_mobile_logo_wrapper__B24aZ","uni_name":"uni_thumb_box_mobile_uni_name__GZlmt","uni_address_wrapper":"uni_thumb_box_mobile_uni_address_wrapper__DjvB1","uni_address":"uni_thumb_box_mobile_uni_address__ikGgs","uni_address_icon":"uni_thumb_box_mobile_uni_address_icon__YBjSp","uni_address_text":"uni_thumb_box_mobile_uni_address_text__M8NPM","uni_review_warpper":"uni_thumb_box_mobile_uni_review_warpper__NqyZA","review_text":"uni_thumb_box_mobile_review_text__aHvxZ","review_icons":"uni_thumb_box_mobile_review_icons__62hjd","icon_heart":"uni_thumb_box_mobile_icon_heart__gL6RK","icon_swap":"uni_thumb_box_mobile_icon_swap__NLM_T","download_btn":"uni_thumb_box_mobile_download_btn___dWwi","courses_wrapper":"uni_thumb_box_mobile_courses_wrapper__Pm8My","course_name":"uni_thumb_box_mobile_course_name__JcRhx","course_desc":"uni_thumb_box_mobile_course_desc__CWbl2","course_head":"uni_thumb_box_mobile_course_head__CMDSB","comp_icons":"uni_thumb_box_mobile_comp_icons__zxJ2v","course_body":"uni_thumb_box_mobile_course_body__15yWC","course_link":"uni_thumb_box_mobile_course_link__vwoXy","exams":"uni_thumb_box_mobile_exams__RPBRX","examNumber":"uni_thumb_box_mobile_examNumber__Lt_Y1","examlist":"uni_thumb_box_mobile_examlist__YiaU6"};

/***/ }),

/***/ 8202:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"uni_thumb_list_box___next__j10kT","grid_box":"uni_thumb_list_box_grid_box__wzs9h","head_wrapper":"uni_thumb_list_box_head_wrapper__35QOM","left":"uni_thumb_list_box_left__rrAMe","logo_wrapper":"uni_thumb_list_box_logo_wrapper__SYusL","logo":"uni_thumb_list_box_logo__XlO6K","infos":"uni_thumb_list_box_infos__82PrR","name":"uni_thumb_list_box_name__lmMeH","info":"uni_thumb_list_box_info__p9w_g","icon":"uni_thumb_list_box_icon__Uz2uC","address":"uni_thumb_list_box_address__vMlbN","link_course":"uni_thumb_list_box_link_course__VrDh7","brief_right_wrapper":"uni_thumb_list_box_brief_right_wrapper__0SsPc","info_rating_stars":"uni_thumb_list_box_info_rating_stars__0kECv","info_rating_number":"uni_thumb_list_box_info_rating_number__uEOie","uni_web_link":"uni_thumb_list_box_uni_web_link__4QLTJ","compare_wrapper":"uni_thumb_list_box_compare_wrapper__dMbyn","icon_heart":"uni_thumb_list_box_icon_heart__NuBDq","selected":"uni_thumb_list_box_selected__B8pty","icon_swap":"uni_thumb_list_box_icon_swap__cV_B7","link_photo_video":"uni_thumb_list_box_link_photo_video__sm7m4","head_link":"uni_thumb_list_box_head_link__ykRvr","heading":"uni_thumb_list_box_heading__SDuKU","external_link":"uni_thumb_list_box_external_link__72ct2","table_wrapper":"uni_thumb_list_box_table_wrapper__kyZOs","view_all_link":"uni_thumb_list_box_view_all_link__2BF_6","favourite_wrapper":"uni_thumb_list_box_favourite_wrapper__pGfe5","eligibility":"uni_thumb_list_box_eligibility__MnGxk","exams":"uni_thumb_list_box_exams__Rw7XO","examNumber":"uni_thumb_list_box_examNumber__9J0jo","examlist":"uni_thumb_list_box_examlist__rYu6M"};

/***/ }),

/***/ 92991:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"soft_bg":"search_filter_soft_bg__RYvzz","section_noresult":"search_filter_section_noresult__Ir_rP","noresult_text_wrapper":"search_filter_noresult_text_wrapper__5ONVH","noresult_title":"search_filter_noresult_title__7O9UO","noresult_sub_text":"search_filter_noresult_sub_text___K_Q1","section_search_hero":"search_filter_section_search_hero__9IN3a","hero_content_wrapper":"search_filter_hero_content_wrapper__bCa0S","heading":"search_filter_heading__DBRE5","search_result_text":"search_filter_search_result_text__btvfI","section_search_filter":"search_filter_section_search_filter__CzRzK","filter_buttons":"search_filter_filter_buttons__uuMKf","moreBtn":"search_filter_moreBtn__p8eoc","filter_indectors":"search_filter_filter_indectors__x5qHa","filter_Collapsable":"search_filter_filter_Collapsable__3O8z7","filter_expanded":"search_filter_filter_expanded__ZuIr_","filter_btngroup":"search_filter_filter_btngroup__4YOAs","close":"search_filter_close__T9Ioo","wrapper":"search_filter_wrapper__Ny0ug","filter_desktop":"search_filter_filter_desktop__SPPcI","uni_box_wrapper":"search_filter_uni_box_wrapper__DTYGI","loader":"search_filter_loader__qVgE_","filter_title_reset":"search_filter_filter_title_reset__zsVv_","title":"search_filter_title__OWW_2","reset":"search_filter_reset__JIqfl","filter_option_wrapper":"search_filter_filter_option_wrapper__6xwXc","pagination_wrapper":"search_filter_pagination_wrapper__9mno2","shwing_num":"search_filter_shwing_num__D9zIY","filter_drawer":"search_filter_filter_drawer__n7YGS","filter_all_btn_wrapper":"search_filter_filter_all_btn_wrapper__bU9tX","thumb_box_desktop":"search_filter_thumb_box_desktop__4qQAx","thumb_box_mobile":"search_filter_thumb_box_mobile__BKSPC","filter_and_indector_wrapper":"search_filter_filter_and_indector_wrapper__DAn5e","filter_btn_wrapper":"search_filter_filter_btn_wrapper__jBygR","btn_filter":"search_filter_btn_filter__RGVhu","indector_wrapper":"search_filter_indector_wrapper__GDvY3","filter_drawer_head":"search_filter_filter_drawer_head__k8tCV","filter_title":"search_filter_filter_title__X7NUl","close_icon":"search_filter_close_icon__tndlE","filter_indector_wrapper":"search_filter_filter_indector_wrapper__TZUxe"};

/***/ }),

/***/ 42891:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"message_component_wrapper":"message_message_component_wrapper__1ieyP","buddy_msg_wrapper":"message_buddy_msg_wrapper__DK00E","msg_time":"message_msg_time__pkHde","msg_wrapper":"message_msg_wrapper__bcN0z","image_wrapper":"message_image_wrapper__75POr","replymsg":"message_replymsg__Q1uk8","my_msg_time":"message_my_msg_time__RxJqO","my_msg":"message_my_msg__0MTvI","mark":"message_mark__3uB3z","heading":"message_heading__nN8Pc","details_wrapper":"message_details_wrapper__KVYfo","msg_footer_wrapper":"message_msg_footer_wrapper__S9kxU","action":"message_action__0Olen","left":"message_left__1Zl0o","action_btn":"message_action_btn__l9bDv","conversation_wrapper":"message_conversation_wrapper__YdB1H","conversation_wrapper_child":"message_conversation_wrapper_child__50fY7","details_wrapper2":"message_details_wrapper2__mMBhj","empty_detail_wrapper":"message_empty_detail_wrapper__SuI8J","my_msg_wrapper":"message_my_msg_wrapper__PTorz","heading_menu":"message_heading_menu__Kqe7o"};

/***/ }),

/***/ 6867:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"active_chatt_box":"list_active_chatt_box__MbZyB","chatt":"list_chatt__Y9S5q","time":"list_time__brnw_","image_wrapper":"list_image_wrapper__waMIN","active_chatt_box_modal":"list_active_chatt_box_modal___BrsY","chatt_box":"list_chatt_box__GiEyE","chatt_msg":"list_chatt_msg__KF_sP","chatt_box_wrapper":"list_chatt_box_wrapper__4qk6k","list_wrapper":"list_list_wrapper__DX7IH","search_input":"list_search_input__2YMvn","search_icon":"list_search_icon__3ZZ8U","header_wrapper":"list_header_wrapper__elCsP","btn_group":"list_btn_group__POPeU","search_input_modal":"list_search_input_modal___ZcDT","modal_body":"list_modal_body__nHnG8","no_found":"list_no_found__wMd8W","btn_close":"list_btn_close__2T9Vb","btn_add_user":"list_btn_add_user__9cjH4","btn_plus":"list_btn_plus__B7L_4"};

/***/ }),

/***/ 83618:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14666);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28811);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2937);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14882);




function _toArray(arr) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}

/***/ })

}]);